"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8559],{

/***/ 88375:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var addToCart = function addToCart(data) {
  var _data$product, _data$product$price, _data$product2;
  var value = data == null ? void 0 : (_data$product = data.product) == null ? void 0 : (_data$product$price = _data$product.price) == null ? void 0 : _data$product$price.fullPrice;
  var prodId = data == null ? void 0 : (_data$product2 = data.product) == null ? void 0 : _data$product2.variationId;
  if (/^[0-9]+$/.test(prodId)) {
    prodId = "PLA-".concat(prodId.substring(0, 7));
  } else {
    prodId = "PLA-".concat(prodId);
  }
  window.uetq = window.uetq || [];
  window.uetq.push('event', 'add_to_cart', {
    currency: 'BRL',
    ecomm_pagetype: 'product',
    ecomm_prodid: prodId,
    ecomm_totalvalue: value,
    items: [{
      id: prodId,
      price: value,
      quantity: 1
    }],
    revenue_value: value
  });
};
/* harmony default export */ __webpack_exports__["default"] = (addToCart);

/***/ }),

/***/ 10482:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _addToCart__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88375);
/* harmony import */ var _pageView__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48863);


var Bing = {
  pageview: [_pageView__WEBPACK_IMPORTED_MODULE_0__["default"]],
  'product:addToCart': [_addToCart__WEBPACK_IMPORTED_MODULE_1__["default"]]
};
/* harmony default export */ __webpack_exports__["default"] = (Bing);

/***/ }),

/***/ 48863:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _utils_formatProductIdBing__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29841);

var pageView = function pageView(_ref) {
  var _structure$route, _data$search, _data$search$term, _data$product, _structure$route2;
  var structure = _ref.structure,
    data = _ref.data;
  window.uetq = window.uetq || [];
  var pageId = structure == null ? void 0 : structure.id;
  var categoryId = structure == null ? void 0 : (_structure$route = structure.route) == null ? void 0 : _structure$route.categoryId;
  var searchTerm = data == null ? void 0 : (_data$search = data.search) == null ? void 0 : (_data$search$term = _data$search.term) == null ? void 0 : _data$search$term.refined;
  var bingProductId = (0,_utils_formatProductIdBing__WEBPACK_IMPORTED_MODULE_0__["default"])(data == null ? void 0 : (_data$product = data.product) == null ? void 0 : _data$product.variationId);
  var subCategoryId = structure == null ? void 0 : (_structure$route2 = structure.route) == null ? void 0 : _structure$route2.subCategoryId;
  var ecommType = {
    category: {
      ecomm_category: categoryId,
      ecomm_pagetype: 'category'
    },
    home: {
      ecomm_pagetype: 'home'
    },
    other: {
      ecomm_pagetype: 'other'
    },
    product: {
      ecomm_pagetype: 'product',
      ecomm_prodid: bingProductId
    },
    search: {
      ecomm_pagetype: 'searchresults',
      ecomm_query: searchTerm
    },
    subcategory: {
      ecomm_category: "".concat(categoryId, "-").concat(subCategoryId),
      ecomm_pagetype: 'category'
    }
  };
  var ecommParams = ecommType[pageId] || ecommType.other;
  window.uetq.push('event', '', ecommParams);
};
/* harmony default export */ __webpack_exports__["default"] = (pageView);

/***/ }),

/***/ 29841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var formatProductIdBing = function formatProductIdBing(productId) {
  if (!productId) return '';
  var strProductId = String(productId);
  if (/^\d+$/.test(strProductId)) {
    var transformedProductId = strProductId.length === 8 ? "0".concat(strProductId) : strProductId;
    return "PLA-".concat(transformedProductId.substring(0, 7));
  }
  return "PLA-".concat(strProductId);
};
/* harmony default export */ __webpack_exports__["default"] = (formatProductIdBing);

/***/ }),

/***/ 33373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var addToCart = function addToCart(data) {
  var _structure$cookies, _structure$cookies$ac;
  var product = data.product,
    structure = data.structure;
  var userId = (structure == null ? void 0 : (_structure$cookies = structure.cookies) == null ? void 0 : (_structure$cookies$ac = _structure$cookies.accountData) == null ? void 0 : _structure$cookies$ac.customer_id) || null;
  return {
    cloud_retail: {
      eventType: 'add-to-cart',
      productDetails: [{
        product: {
          id: product.variationId
        },
        quantity: 1
      }],
      userInfo: {
        userId: userId
      }
    },
    event: 'cloud_retail'
  };
};
/* harmony default export */ __webpack_exports__["default"] = (addToCart);

/***/ }),

/***/ 80548:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var category = function category() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$products = _ref.products,
    products = _ref$products === void 0 ? [] : _ref$products,
    userId = _ref.customer_id,
    offset = _ref.offset,
    attributionToken = _ref.attributionToken,
    pageName = _ref.pageName,
    categoryInfo = _ref.category,
    abTesting = _ref.abTesting;
  if (pageName === 'categoria' && abTesting) {
    var _categoryInfo$;
    var categoryLabel = categoryInfo == null ? void 0 : (_categoryInfo$ = categoryInfo[0]) == null ? void 0 : _categoryInfo$.id;
    var pageCategories = [categoryLabel];
    var productDetails = products.map(function (product) {
      return {
        product: {
          id: product.variationId
        }
      };
    });
    return {
      cloud_retail: {
        attributionToken: attributionToken,
        eventType: 'search',
        offset: offset,
        pageCategories: pageCategories,
        productDetails: productDetails,
        userInfo: {
          userId: userId
        }
      },
      event: 'cloud_retail'
    };
  }
  return null;
};
/* harmony default export */ __webpack_exports__["default"] = (category);

/***/ }),

/***/ 57046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _GA4_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45842);
/* harmony import */ var _addToCart__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33373);
/* harmony import */ var _search__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89913);
/* harmony import */ var _viewItem__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78336);
/* harmony import */ var _category__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80548);
/* harmony import */ var _subCategory__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79564);






var events = {
  'product:addToCart': [(0,_GA4_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_addToCart__WEBPACK_IMPORTED_MODULE_1__["default"])],
  'product:details': [(0,_GA4_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_viewItem__WEBPACK_IMPORTED_MODULE_2__["default"])],
  'productlist:impression': [(0,_GA4_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_search__WEBPACK_IMPORTED_MODULE_3__["default"]), (0,_GA4_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_category__WEBPACK_IMPORTED_MODULE_4__["default"]), (0,_GA4_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_subCategory__WEBPACK_IMPORTED_MODULE_5__["default"])]
};
/* harmony default export */ __webpack_exports__["default"] = (events);

/***/ }),

/***/ 89913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var search = function search() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$products = _ref.products,
    products = _ref$products === void 0 ? [] : _ref$products,
    pageName = _ref.pageName,
    userId = _ref.customer_id,
    term = _ref.term,
    offset = _ref.offset,
    attributionToken = _ref.attributionToken;
  if (pageName === 'busca' && (products == null ? void 0 : products.length)) {
    var productDetails = products.map(function (product) {
      return {
        product: {
          id: product.variationId
        }
      };
    });
    return {
      cloud_retail: {
        attributionToken: attributionToken,
        eventType: 'search',
        offset: offset,
        productDetails: productDetails,
        searchQuery: term,
        userInfo: {
          userId: userId
        }
      },
      event: 'cloud_retail'
    };
  }
  return null;
};
/* harmony default export */ __webpack_exports__["default"] = (search);

/***/ }),

/***/ 79564:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85942);

var subCategory = function subCategory() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$products = _ref.products,
    products = _ref$products === void 0 ? [] : _ref$products,
    userId = _ref.customer_id,
    offset = _ref.offset,
    attributionToken = _ref.attributionToken,
    pageName = _ref.pageName,
    categoryInfo = _ref.category,
    abTesting = _ref.abTesting;
  if (pageName === 'subcategoria' && abTesting) {
    var _categoryInfo$, _categoryInfo$2, _categoryInfo$2$subca;
    var categoryLabel = categoryInfo == null ? void 0 : (_categoryInfo$ = categoryInfo[0]) == null ? void 0 : _categoryInfo$.id;
    var subCategories = categoryInfo == null ? void 0 : (_categoryInfo$2 = categoryInfo[0]) == null ? void 0 : (_categoryInfo$2$subca = _categoryInfo$2.subcategories) == null ? void 0 : _categoryInfo$2$subca.flatMap(function (item) {
      return item.id;
    });
    var pageCategories = [categoryLabel].concat((0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(subCategories));
    var productDetails = products.map(function (product) {
      return {
        product: {
          id: product.variationId
        }
      };
    });
    return {
      cloud_retail: {
        attributionToken: attributionToken,
        eventType: 'search',
        offset: offset,
        pageCategories: pageCategories,
        productDetails: productDetails,
        userInfo: {
          userId: userId
        }
      },
      event: 'cloud_retail'
    };
  }
  return null;
};
/* harmony default export */ __webpack_exports__["default"] = (subCategory);

/***/ }),

/***/ 78336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var viewItem = function viewItem(_ref) {
  var _structure$cookies, _structure$cookies$ac;
  var product = _ref.product,
    structure = _ref.structure;
  var userId = (structure == null ? void 0 : (_structure$cookies = structure.cookies) == null ? void 0 : (_structure$cookies$ac = _structure$cookies.accountData) == null ? void 0 : _structure$cookies$ac.customer_id) || null;
  return {
    cloud_retail: {
      eventType: 'detail-page-view',
      productDetails: [{
        product: {
          id: product.variationId
        }
      }],
      userInfo: {
        userId: userId
      }
    },
    event: 'cloud_retail'
  };
};
/* harmony default export */ __webpack_exports__["default"] = (viewItem);

/***/ }),

/***/ 80542:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* reexport safe */ _events__WEBPACK_IMPORTED_MODULE_0__["default"]; }
/* harmony export */ });
/* harmony import */ var _events__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57046);


/***/ }),

/***/ 78224:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "addToAcceptPolityCookies": function() { return /* binding */ addToAcceptPolityCookies; }
/* harmony export */ });
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62624);

var ACCEPT_POLICY = _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .cookiesConstants.ACCEPT_POLICY */ .VD.ACCEPT_POLICY;
var addToAcceptPolityCookies = function addToAcceptPolityCookies() {
  var _structure$config;
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    structure = _ref.structure;
  (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .setCookie */ .d8)({
    domain: structure == null ? void 0 : (_structure$config = structure.config) == null ? void 0 : _structure$config.cookieDomain,
    name: ACCEPT_POLICY,
    value: 'true'
  });
};


/***/ }),

/***/ 72661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "addRejectZipcodePopup": function() { return /* binding */ addRejectZipcodePopup; }
/* harmony export */ });
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62624);

var REJECT_ZIPCODE_POPUP = _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .cookiesConstants.REJECT_ZIPCODE_POPUP */ .VD.REJECT_ZIPCODE_POPUP;
var addRejectZipcodePopup = function addRejectZipcodePopup() {
  var _config$zipcode, _config$zipcode$popup, _structure$config;
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    structure = _ref.structure,
    config = _ref.config;
  var expires = new Date(Date.now() + (config == null ? void 0 : (_config$zipcode = config.zipcode) == null ? void 0 : (_config$zipcode$popup = _config$zipcode.popup) == null ? void 0 : _config$zipcode$popup.rejectPopupExpiresInterval));
  (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .setCookie */ .d8)({
    domain: structure == null ? void 0 : (_structure$config = structure.config) == null ? void 0 : _structure$config.cookieDomain,
    expires: expires,
    name: REJECT_ZIPCODE_POPUP,
    value: 'true'
  });
};


/***/ }),

/***/ 84511:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "addToCartSuccessSetCookies": function() { return /* binding */ addToCartSuccessSetCookies; },
/* harmony export */   "encoder": function() { return /* binding */ encoder; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56666);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62624);


var ML2_SID = _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .cookiesConstants.ML2_SID */ .VD.ML2_SID,
  GA_ADD_TO_CART = _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .cookiesConstants.GA_ADD_TO_CART */ .VD.GA_ADD_TO_CART;
var encoder = function encoder(string) {
  return string;
};
var addToCartSuccessSetCookies = function addToCartSuccessSetCookies(_ref) {
  var _structure$config, _structure$config2;
  var product = _ref.product,
    cartId = _ref.cartId,
    _ref$encode = _ref.encode,
    encode = _ref$encode === void 0 ? encoder : _ref$encode;
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    structure = _ref2.structure;
  (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .setCookie */ .d8)({
    domain: structure == null ? void 0 : (_structure$config = structure.config) == null ? void 0 : _structure$config.cookieDomain,
    encode: encode,
    name: GA_ADD_TO_CART,
    value: [(0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, product == null ? void 0 : product.variationId, product == null ? void 0 : product.id)]
  });
  (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .setCookie */ .d8)({
    domain: structure == null ? void 0 : (_structure$config2 = structure.config) == null ? void 0 : _structure$config2.cookieDomain,
    name: ML2_SID,
    value: cartId
  });
};


/***/ }),

/***/ 30040:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _addAcceptPolity__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78224);
/* harmony import */ var _addToCart__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84511);
/* harmony import */ var _addRejectZipcodePopup__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72661);
/* harmony import */ var _setPageBeforeLogin__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29414);




var events = {
  'addtoacceptpolity:success': [_addAcceptPolity__WEBPACK_IMPORTED_MODULE_0__.addToAcceptPolityCookies],
  'addtocart:success': [_addToCart__WEBPACK_IMPORTED_MODULE_1__.addToCartSuccessSetCookies],
  'addtorejectzipcode:success': [_addRejectZipcodePopup__WEBPACK_IMPORTED_MODULE_2__.addRejectZipcodePopup],
  setpagebeforelogin: [_setPageBeforeLogin__WEBPACK_IMPORTED_MODULE_3__.setPageBeforeLogin]
};
/* harmony default export */ __webpack_exports__["default"] = (events);

/***/ }),

/***/ 29414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "setPageBeforeLogin": function() { return /* binding */ setPageBeforeLogin; }
/* harmony export */ });
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62624);

var PAGE_BEFORE_LOGIN = _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .cookiesConstants.PAGE_BEFORE_LOGIN */ .VD.PAGE_BEFORE_LOGIN;
var setPageBeforeLogin = function setPageBeforeLogin(page) {
  var _structure$cookies;
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    structure = _ref.structure;
  if (structure && !((_structure$cookies = structure.cookies) == null ? void 0 : _structure$cookies.accountData)) {
    var _structure$config;
    (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .setCookie */ .d8)({
      domain: structure == null ? void 0 : (_structure$config = structure.config) == null ? void 0 : _structure$config.cookieDomain,
      name: PAGE_BEFORE_LOGIN,
      value: page
    });
  }
};


/***/ }),

/***/ 79381:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _pageView__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91564);

var Criteo = {
  pageview: [_pageView__WEBPACK_IMPORTED_MODULE_0__["default"]]
};
/* harmony default export */ __webpack_exports__["default"] = (Criteo);

/***/ }),

/***/ 91564:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85942);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33385);


var getView = function getView(_ref) {
  var _data$product, _data$search, _data$search$products;
  var data = _ref.data,
    structure = _ref.structure;
  switch (structure == null ? void 0 : structure.id) {
    case 'home':
      return {
        event: 'viewHome'
      };
    case 'product':
      return {
        event: 'viewItem',
        item: data == null ? void 0 : (_data$product = data.product) == null ? void 0 : _data$product.id
      };
    default:
      return {
        event: 'viewList',
        item: data == null ? void 0 : (_data$search = data.search) == null ? void 0 : (_data$search$products = _data$search.products) == null ? void 0 : _data$search$products.reduce(function (acc, item) {
          return [].concat((0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(acc), [item.id]);
        }, [])
      };
  }
};
var pageView = function pageView() {
  var _window, _window2, _window2$criteo_q;
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    data = _ref2.data,
    structure = _ref2.structure;
  if (_utils_constants__WEBPACK_IMPORTED_MODULE_1__.PAGES.includes(structure == null ? void 0 : structure.id) && ((_window = window) == null ? void 0 : _window.criteo_q) && ((_window2 = window) == null ? void 0 : (_window2$criteo_q = _window2.criteo_q) == null ? void 0 : _window2$criteo_q.push)) {
    var _structure$cookies, _structure$cookies$ac;
    window.criteo_q.push({
      account: _utils_constants__WEBPACK_IMPORTED_MODULE_1__.ACCOUNT,
      event: 'setAccount'
    }, {
      event: 'setSiteType',
      type: _utils_constants__WEBPACK_IMPORTED_MODULE_1__.DOMAIN
    }, {
      email: (structure == null ? void 0 : (_structure$cookies = structure.cookies) == null ? void 0 : (_structure$cookies$ac = _structure$cookies.accountData) == null ? void 0 : _structure$cookies$ac.email) || '',
      event: 'setEmail'
    }, getView({
      data: data,
      structure: structure
    }));
  }
};
/* harmony default export */ __webpack_exports__["default"] = (pageView);

/***/ }),

/***/ 33385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ACCOUNT": function() { return /* binding */ ACCOUNT; },
/* harmony export */   "DOMAIN": function() { return /* binding */ DOMAIN; },
/* harmony export */   "PAGES": function() { return /* binding */ PAGES; }
/* harmony export */ });
var ACCOUNT = [6459, 53315];
var DOMAIN = "m";
var PAGES = ['product', 'home', 'search', 'subcategory'];

/***/ }),

/***/ 51852:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62624);

var stringNormalize = function stringNormalize(label) {
  return (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .normalize */ .Fv)(label == null ? void 0 : label.replace == null ? void 0 : label.replace(/\s/g, '-'));
};
var accountLinkClick = function accountLinkClick(event) {
  return {
    content_id: "".concat(stringNormalize(event == null ? void 0 : event.category), ":").concat(stringNormalize(event == null ? void 0 : event.item)),
    content_type: 'seu-espaco',
    event: 'select_content',
    screenName: 'seu-espaco'
  };
};
/* harmony default export */ __webpack_exports__["default"] = (accountLinkClick);

/***/ }),

/***/ 86963:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7896);
/* harmony import */ var _utils_itemVariantParser__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58338);
/* harmony import */ var _utils_parseUrl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62322);
/* harmony import */ var _utils_addToCartDimensions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33637);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62624);
/* harmony import */ var _utils_formattedTagSelo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19175);






var ML2_SID = _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .cookiesConstants.ML2_SID */ .VD.ML2_SID;
var parseItemCategory = function parseItemCategory(category, subcategory) {
  var categoryId = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)((category == null ? void 0 : category.id) || 'null');
  var subcategoryId = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)((subcategory == null ? void 0 : subcategory.id) || 'null');
  return "".concat(categoryId, "/").concat(subcategoryId);
};
var getProductPrice = function getProductPrice(data) {
  var _data$product, _data$product$price, _data$product2, _data$product2$price, _data$product3, _data$product3$instal;
  var bestPrice = parseFloat(data == null ? void 0 : (_data$product = data.product) == null ? void 0 : (_data$product$price = _data$product.price) == null ? void 0 : _data$product$price.bestPrice);
  var fullPrice = parseFloat(data == null ? void 0 : (_data$product2 = data.product) == null ? void 0 : (_data$product2$price = _data$product2.price) == null ? void 0 : _data$product2$price.fullPrice);
  var installmentTotal = parseFloat(data == null ? void 0 : (_data$product3 = data.product) == null ? void 0 : (_data$product3$instal = _data$product3.installment) == null ? void 0 : _data$product3$instal.totalAmount);
  return (data == null ? void 0 : data.pageName) === 'buybox' ? bestPrice || fullPrice || null : installmentTotal || fullPrice || bestPrice || null;
};
var parseEcommerce = function parseEcommerce(data) {
  var _data$product4, _data$product4$brand, _data$product5, _data$product6, _data$product7, _data$product7$rating, _data$product7$rating2, _data$product8, _data$product8$rating, _data$product8$rating2, _data$product9, _data$product$seller$, _data$product10, _data$product10$selle, _data$product$seller$2, _data$product11, _data$product11$selle, _data$product12, _data$product13, _data$product14, _data$product15;
  var _formattedTagSeal = (0,_utils_formattedTagSelo__WEBPACK_IMPORTED_MODULE_2__.formattedTagSeal)(data == null ? void 0 : data.product),
    seal = _formattedTagSeal.seal,
    tag = _formattedTagSeal.tag;
  return {
    items: [(0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
      item_brand: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)((data == null ? void 0 : (_data$product4 = data.product) == null ? void 0 : (_data$product4$brand = _data$product4.brand) == null ? void 0 : _data$product4$brand.label) || 'null'),
      item_category: parseItemCategory(data == null ? void 0 : (_data$product5 = data.product) == null ? void 0 : _data$product5.category, data == null ? void 0 : (_data$product6 = data.product) == null ? void 0 : _data$product6.subcategory),
      item_category3: "qtd-av:".concat((data == null ? void 0 : (_data$product7 = data.product) == null ? void 0 : (_data$product7$rating = _data$product7.rating) == null ? void 0 : (_data$product7$rating2 = _data$product7$rating.count) == null ? void 0 : _data$product7$rating2.toString()) || null, "|av:").concat((data == null ? void 0 : (_data$product8 = data.product) == null ? void 0 : (_data$product8$rating = _data$product8.rating) == null ? void 0 : (_data$product8$rating2 = _data$product8$rating.score) == null ? void 0 : _data$product8$rating2.toString()) || null, "|").concat((data == null ? void 0 : (_data$product9 = data.product) == null ? void 0 : _data$product9.available) ? 'verdadeiro' : 'falso:sem-estoque'),
      item_category4: "ven-por:".concat((_data$product$seller$ = data == null ? void 0 : (_data$product10 = data.product) == null ? void 0 : (_data$product10$selle = _data$product10.seller) == null ? void 0 : _data$product10$selle.id) !== null && _data$product$seller$ !== void 0 ? _data$product$seller$ : null, "|ent-por:").concat((_data$product$seller$2 = data == null ? void 0 : (_data$product11 = data.product) == null ? void 0 : (_data$product11$selle = _data$product11.seller) == null ? void 0 : _data$product11$selle.deliveryId) !== null && _data$product$seller$2 !== void 0 ? _data$product$seller$2 : null),
      item_category5: "selo:".concat(seal, "|tag:").concat(tag),
      item_id: (data == null ? void 0 : (_data$product12 = data.product) == null ? void 0 : _data$product12.variationId) || null,
      item_list_name: "".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)((data == null ? void 0 : data.pageName) || 'null'), ":").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)((data == null ? void 0 : (_data$product13 = data.product) == null ? void 0 : _data$product13.list) || 'null')),
      item_name: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)((data == null ? void 0 : (_data$product14 = data.product) == null ? void 0 : _data$product14.title) || 'null').replace(/[_\s]/g, '-').toLowerCase().slice(0, 99),
      item_variant: (0,_utils_itemVariantParser__WEBPACK_IMPORTED_MODULE_4__.itemVariantParser)(data == null ? void 0 : (_data$product15 = data.product) == null ? void 0 : _data$product15.attributes) || null,
      price: getProductPrice(data),
      quantity: (data == null ? void 0 : data.quantity) || 1
    }, (0,_utils_addToCartDimensions__WEBPACK_IMPORTED_MODULE_0__.addToCartDimensions)(data))]
  };
};
var addToCart = function addToCart(newData) {
  var _newData$product, _newData$product2, _newData$product3, _data$customer_id;
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    eventId = _ref.eventId;
  var data = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, newData, {
    product: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, newData.product, {
      category: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, newData.product.category, {
        id: newData.product.category.id || (0,_utils_parseUrl__WEBPACK_IMPORTED_MODULE_5__.parseUrl)(newData == null ? void 0 : (_newData$product = newData.product) == null ? void 0 : _newData$product.url, 1)
      }),
      subcategory: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, newData.product.subcategory, {
        id: newData.product.subcategory.id || (0,_utils_parseUrl__WEBPACK_IMPORTED_MODULE_5__.parseUrl)(newData == null ? void 0 : (_newData$product2 = newData.product) == null ? void 0 : _newData$product2.url, 2)
      }),
      variationId: newData.product.variationId || (0,_utils_parseUrl__WEBPACK_IMPORTED_MODULE_5__.parseUrl)(newData == null ? void 0 : (_newData$product3 = newData.product) == null ? void 0 : _newData$product3.url, 0)
    })
  });
  var getEventLabel = function getEventLabel(label) {
    if (label == null ? void 0 : label.typeButton.includes('oneTouch')) {
      return 'comprar-agora';
    }
    if (label == null ? void 0 : label.typeButton.includes('addToBag')) {
      return 'adicionar-a-sacola';
    }
    if (label == null ? void 0 : label.typeButton.includes('pickupStore')) {
      return 'retirar-na-loja';
    }
    return null;
  };
  var basketId = newData.cartId || (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .getCookie */ .ej)(ML2_SID) || null;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    basketId: basketId,
    event: 'add_to_cart',
    eventCategory: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)(data == null ? void 0 : data.pageName) || null,
    eventId: eventId,
    eventLabel: getEventLabel(data),
    idUsuario: (_data$customer_id = data == null ? void 0 : data.customer_id) !== null && _data$customer_id !== void 0 ? _data$customer_id : null,
    mundos: 'magalu',
    screenName: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)(data == null ? void 0 : data.pageName) || null
  }, parseEcommerce(data));
};
/* harmony default export */ __webpack_exports__["default"] = (addToCart);

/***/ }),

/***/ 81760:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85942);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62624);


var categories = [{
  id: 3,
  name: 'GE12'
}, {
  id: 4,
  name: 'GE24'
}, {
  id: 9,
  name: 'GE36'
}, {
  id: 7,
  name: 'RF12'
}, {
  id: 8,
  name: 'RF24'
}, {
  id: 5,
  name: 'TC12'
}, {
  id: 6,
  name: 'TC24'
}, {
  id: 10,
  name: 'TC36'
}];
var parseEcommerce = function parseEcommerce(value) {
  var _value$product, _value$product$financ;
  var validServiceIds = (value == null ? void 0 : value.services) || [];
  var fullPrice = 0;
  var filteredOptions = value.adaptedServices.flatMap(function (item) {
    return item.period.options.filter(function (option) {
      return option.checked;
    });
  });
  var items = (value == null ? void 0 : (_value$product = value.product) == null ? void 0 : (_value$product$financ = _value$product.financialServices) == null ? void 0 : _value$product$financ.flatMap(function (itemService) {
    return itemService.offers.filter(function (offer) {
      return validServiceIds.includes(offer.id);
    }).map(function (offer) {
      var _categories$find, _value$product2;
      var nameFound = ((_categories$find = categories.find(function (cat) {
        return cat.id === offer.id;
      })) == null ? void 0 : _categories$find.name) || '';
      fullPrice += Number(offer.price) || 0;
      var matched = filteredOptions.find(function (opt) {
        return opt.value === offer.id;
      });
      return {
        dimension87: "tag:".concat((matched == null ? void 0 : matched.recommended) ? 'recomendado' : 'sem-tag'),
        item_category: "servicos/".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(offer.description || '')),
        item_id: offer.id,
        item_name: nameFound,
        item_variant: value == null ? void 0 : (_value$product2 = value.product) == null ? void 0 : _value$product2.id,
        price: offer.price,
        quantity: 1
      };
    });
  })) || [];
  return {
    fullPrice: fullPrice,
    items: items
  };
};
var addToCartWarranty = function addToCartWarranty(_ref) {
  var _window, _window$crypto;
  var value = _ref.value;
  var eventId = (_window = window) == null ? void 0 : (_window$crypto = _window.crypto) == null ? void 0 : _window$crypto.randomUUID == null ? void 0 : _window$crypto.randomUUID();
  var userId = (value == null ? void 0 : value.customerId) || null;
  var _parseEcommerce = parseEcommerce(value),
    fullPrice = _parseEcommerce.fullPrice,
    items = _parseEcommerce.items;
  return {
    currency: 'BRL',
    event: 'add_to_cart',
    eventId: eventId,
    eventLabel: 'seguro:incluir-protecao',
    idUsuario: userId || null,
    items: (0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(items),
    loginAtivo: userId ? 'logado' : 'nao-logado',
    screenName: 'seguro',
    value: fullPrice
  };
};
/* harmony default export */ __webpack_exports__["default"] = (addToCartWarranty);

/***/ }),

/***/ 72003:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7896);
/* harmony import */ var _utils_itemVariantParser__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58338);
/* harmony import */ var _utils_parseUrl__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62322);
/* harmony import */ var _utils_addToWishlistDimensions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8886);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62624);
/* harmony import */ var _utils_discountCalc__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80746);
/* harmony import */ var _utils_formattedTagSelo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19175);







var parseItemCategory = function parseItemCategory(category, subcategory) {
  var categoryId = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)((category == null ? void 0 : category.id) || 'null');
  var subcategoryId = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)((subcategory == null ? void 0 : subcategory.id) || 'null');
  return "".concat(categoryId, "/").concat(subcategoryId);
};
var priceValue = function priceValue(val) {
  var _val$installment, _val$price, _val$price2;
  return parseFloat(val == null ? void 0 : (_val$installment = val.installment) == null ? void 0 : _val$installment.totalAmount) || parseFloat(val == null ? void 0 : (_val$price = val.price) == null ? void 0 : _val$price.fullPrice) || parseFloat(val == null ? void 0 : (_val$price2 = val.price) == null ? void 0 : _val$price2.bestPrice) || null;
};
var parseEcommerce = function parseEcommerce(data) {
  var _data$brand, _data$brand$label, _data$rating, _data$rating$count, _data$rating2, _data$rating2$score, _data$seller$id, _data$seller, _data$seller$delivery, _data$seller2;
  var _formattedTagSeal = (0,_utils_formattedTagSelo__WEBPACK_IMPORTED_MODULE_2__.formattedTagSeal)(data),
    seal = _formattedTagSeal.seal,
    tag = _formattedTagSeal.tag;
  return {
    items: [(0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
      discount: (0,_utils_discountCalc__WEBPACK_IMPORTED_MODULE_4__.getNominalDiscountValue)(data == null ? void 0 : data.installment, data == null ? void 0 : data.price),
      index: (data == null ? void 0 : data.position) || null,
      item_brand: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)((data == null ? void 0 : (_data$brand = data.brand) == null ? void 0 : (_data$brand$label = _data$brand.label) == null ? void 0 : _data$brand$label.slice(0, 99)) || 'null'),
      item_category: parseItemCategory(data == null ? void 0 : data.category, data == null ? void 0 : data.subcategory),
      item_category3: "qtd-av:".concat((data == null ? void 0 : (_data$rating = data.rating) == null ? void 0 : (_data$rating$count = _data$rating.count) == null ? void 0 : _data$rating$count.toString()) || null, "|av:").concat((data == null ? void 0 : (_data$rating2 = data.rating) == null ? void 0 : (_data$rating2$score = _data$rating2.score) == null ? void 0 : _data$rating2$score.toString()) || null, "|").concat((data == null ? void 0 : data.available) ? 'verdadeiro' : 'falso:sem-estoque'),
      item_category4: "ven-por:".concat((_data$seller$id = data == null ? void 0 : (_data$seller = data.seller) == null ? void 0 : _data$seller.id) !== null && _data$seller$id !== void 0 ? _data$seller$id : null, "|ent-por:").concat((_data$seller$delivery = data == null ? void 0 : (_data$seller2 = data.seller) == null ? void 0 : _data$seller2.deliveryId) !== null && _data$seller$delivery !== void 0 ? _data$seller$delivery : null),
      item_category5: "selo:".concat(seal, "|tag:").concat(tag),
      item_id: (data == null ? void 0 : data.variationId) || null,
      item_list_name: "".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)((data == null ? void 0 : data.pageName) || 'null'), ":").concat((data == null ? void 0 : data.term) || (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)((data == null ? void 0 : data.list) || 'null')),
      item_name: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)((data == null ? void 0 : data.title) || 'null').replace(/[_\s]/g, '-').toLowerCase().slice(0, 99),
      item_variant: (0,_utils_itemVariantParser__WEBPACK_IMPORTED_MODULE_5__.itemVariantParser)(data == null ? void 0 : data.attributes) || null,
      price: priceValue(data),
      quantity: 1
    }, (0,_utils_addToWishlistDimensions__WEBPACK_IMPORTED_MODULE_0__.addToWishlistDimensions)(data))]
  };
};
var addToWishlist = function addToWishlist(newData) {
  var _data$customer_id, _data$installment, _data$price, _data$price2;
  var data = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, newData, {
    category: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, newData.category, {
      id: newData.category.id || (0,_utils_parseUrl__WEBPACK_IMPORTED_MODULE_6__.parseUrl)(newData == null ? void 0 : newData.url, 1)
    }),
    subcategory: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, newData.subcategory, {
      id: newData.subcategory.id || (0,_utils_parseUrl__WEBPACK_IMPORTED_MODULE_6__.parseUrl)(newData == null ? void 0 : newData.url, 2)
    }),
    variationId: newData.variationId || (0,_utils_parseUrl__WEBPACK_IMPORTED_MODULE_6__.parseUrl)(newData == null ? void 0 : newData.url, 0)
  });
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    currency: 'BRL',
    event: 'add_to_wishlist',
    idUsuario: (_data$customer_id = data == null ? void 0 : data.customer_id) !== null && _data$customer_id !== void 0 ? _data$customer_id : null,
    item_list_name: "".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)((data == null ? void 0 : data.pageName) || 'null'), ":").concat((data == null ? void 0 : data.term) || (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)((data == null ? void 0 : data.list) || 'null')),
    loginAtivo: (data == null ? void 0 : data.customer_id) ? 'logado' : 'null',
    mundos: 'magalu',
    screenName: (data == null ? void 0 : data.pageName) || null,
    value: parseFloat(data == null ? void 0 : (_data$installment = data.installment) == null ? void 0 : _data$installment.totalAmount) || parseFloat(data == null ? void 0 : (_data$price = data.price) == null ? void 0 : _data$price.fullPrice) || parseFloat(data == null ? void 0 : (_data$price2 = data.price) == null ? void 0 : _data$price2.bestPrice) || null
  }, parseEcommerce(data));
};
/* harmony default export */ __webpack_exports__["default"] = (addToWishlist);

/***/ }),

/***/ 21384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "allBrandVirtualPageview": function() { return /* binding */ allBrandVirtualPageview; },
/* harmony export */   "allBrandsLetterFilterClick": function() { return /* binding */ allBrandsLetterFilterClick; },
/* harmony export */   "brandClick": function() { return /* binding */ brandClick; },
/* harmony export */   "buildEvent": function() { return /* binding */ buildEvent; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7896);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62624);


var formatLocation = function formatLocation(location) {
  if ((location == null ? void 0 : location.zipCodeCity) && (location == null ? void 0 : location.zipCodeState)) {
    return "cep:".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(location.zipCode), ":").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(location.zipCodeCity), ":").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(location.zipCodeState));
  }
  return null;
};
var getLoginStatus = function getLoginStatus(customerId) {
  return customerId ? 'logado' : 'nao-logado';
};
var buildEvent = function buildEvent(_ref) {
  var args = _ref.args;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    event: 'select_content',
    screenName: 'marcas'
  }, args);
};
var allBrandsLetterFilterClick = function allBrandsLetterFilterClick() {
  var _value$letter;
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    value = _ref2.value;
  var letter = value == null ? void 0 : (_value$letter = value.letter) == null ? void 0 : _value$letter.toLowerCase();
  return buildEvent({
    args: {
      content_id: letter ? "inicial:".concat(letter) : undefined,
      content_type: 'marcas'
    }
  });
};
var brandClick = function brandClick() {
  var _value$slug;
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    value = _ref3.value;
  var brand = value == null ? void 0 : (_value$slug = value.slug) == null ? void 0 : _value$slug.toLowerCase();
  return buildEvent({
    args: {
      content_id: brand ? "marca:".concat(brand) : undefined,
      content_type: 'marcas'
    }
  });
};
var allBrandVirtualPageview = function allBrandVirtualPageview(_ref4) {
  var _structure$cookies2, _data$product, _data$product$categor, _data$product2, _data$product2$subcat;
  var data = _ref4.data,
    structure = _ref4.structure;
  var siteId = structure.id,
    _structure$cookies = structure.cookies,
    cookies = _structure$cookies === void 0 ? {} : _structure$cookies,
    device = structure.device;
  var cookiesLocation = cookies == null ? void 0 : cookies.location;
  var accountData = ((_structure$cookies2 = structure.cookies) == null ? void 0 : _structure$cookies2.accountData) || null;
  var customerId = (accountData == null ? void 0 : accountData.customer_id) || null;
  var clientId = (cookies == null ? void 0 : cookies.clientId) || null;
  var category = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(data == null ? void 0 : (_data$product = data.product) == null ? void 0 : (_data$product$categor = _data$product.category) == null ? void 0 : _data$product$categor.id) || null;
  var subCategory = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(data == null ? void 0 : (_data$product2 = data.product) == null ? void 0 : (_data$product2$subcat = _data$product2.subcategory) == null ? void 0 : _data$product2$subcat.id) || null;
  var location = {
    zipCode: cookiesLocation == null ? void 0 : cookiesLocation.zipCode,
    zipCodeCity: cookiesLocation == null ? void 0 : cookiesLocation.zipCodeCity,
    zipCodeState: cookiesLocation == null ? void 0 : cookiesLocation.zipCodeState
  };
  if (siteId === 'all-brands') {
    return {
      buybox: 1,
      cepPreenchido: location.zipCode ? 1 : 0,
      cidadeuf: formatLocation(location),
      clientId: clientId,
      device: device || null,
      event: 'virtualPageview',
      fbc: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .getCookie */ .ej)('_fbc'),
      fbp: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .getCookie */ .ej)('_fbp'),
      idUsuario: customerId || null,
      loginAtivo: getLoginStatus(customerId),
      mundos: 'magalu',
      pageCategory: "".concat(category || null, ":").concat(subCategory || null),
      pageType: 'marcas',
      screenName: 'marcas',
      usuarioClube: null
    };
  }
  return null;
};

/***/ }),

/***/ 82022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var formatValue = function formatValue(value) {
  return parseFloat(value || 0).toFixed(2);
};
var calculateTaxes = function calculateTaxes(taxes) {
  return {
    event: 'tax',
    imposto: "".concat(formatValue(taxes == null ? void 0 : taxes.importTax), "|icms:").concat(formatValue(taxes == null ? void 0 : taxes.icms)),
    screenName: 'produto'
  };
};
/* harmony default export */ __webpack_exports__["default"] = (calculateTaxes);

/***/ }),

/***/ 30821:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CHAR_MAP": function() { return /* binding */ CHAR_MAP; },
/* harmony export */   "CURRENCY": function() { return /* binding */ CURRENCY; },
/* harmony export */   "DELIVERY": function() { return /* binding */ DELIVERY; },
/* harmony export */   "GENERAL_PRODUCT": function() { return /* binding */ GENERAL_PRODUCT; }
/* harmony export */ });
var CHAR_MAP = {
  à: 'a',
  á: 'a',
  â: 'a',
  ã: 'a',
  ä: 'a',
  å: 'a',
  ç: 'c',
  è: 'e',
  é: 'e',
  ê: 'e',
  ë: 'e',
  ì: 'i',
  í: 'i',
  î: 'i',
  ï: 'i',
  ñ: 'n',
  ò: 'o',
  ó: 'o',
  ô: 'o',
  õ: 'o',
  ö: 'o',
  ù: 'u',
  ú: 'u',
  û: 'u',
  ü: 'u'
};
var CURRENCY = 'BRL';
var DELIVERY = {
  delivery_24h: 'entrega-em-1-dia-util',
  delivery_plus_1: 'entrega-em-2-dias-uteis',
  magalu_indica: 'magalu-indica',
  'magalu-entregas': 'entregue-por-magalu',
  'magalu-partner': 'perto-de-voce',
  promocao_sazonal_1: 'ofertas-de-natal',
  promocao_sazonal_2: 'cupons',
  promocao_sazonal_3: 'super-ofertas',
  promocao_sazonal_4: 'ofertas-fantasticas',
  store_pickup_available: 'retira-na-loja'
};
var GENERAL_PRODUCT = 'produto:geral';

/***/ }),

/***/ 38015:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "couponClick": function() { return /* binding */ couponClick; },
/* harmony export */   "couponView": function() { return /* binding */ couponView; }
/* harmony export */ });
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62624);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30821);


var slugifyCouponTitle = function slugifyCouponTitle(couponTitle) {
  if (!couponTitle) return '';
  var dollarSign = /R\$\s?(\d+)/;
  var thousandSeparator = /\.(\d{3})/g;
  var decimals = /,\d+/;
  var specialCharacters = /[,%!]/g;
  var dictionary = /[àáâãäåçèéêëìíîïñòóôõöùúûü]/g;
  var str = couponTitle.trim().replace(dollarSign, 'r$1').replace(thousandSeparator, '$1').replace(decimals, '').replace(specialCharacters, '').replace(dictionary, function (match) {
    return _constants__WEBPACK_IMPORTED_MODULE_1__.CHAR_MAP[match] || match;
  });
  return (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(str);
};
var couponClick = function couponClick(data) {
  var couponName = data.couponName,
    sectionTitle = data.sectionTitle,
    screenName = data.screenName;
  return {
    content_id: "copiar-cupom:".concat(slugifyCouponTitle(sectionTitle), ":").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(couponName)),
    content_type: screenName,
    event: 'select_content'
  };
};
var couponView = function couponView(data) {
  var couponName = data.couponName,
    sectionTitle = data.sectionTitle,
    screenName = data.screenName;
  return {
    content_id: "cupom-disponivel:".concat(slugifyCouponTitle(sectionTitle), ":").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(couponName)),
    content_type: screenName,
    event: 'view_content'
  };
};

/***/ }),

/***/ 65086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "buildFilterClick": function() { return /* binding */ buildFilterClick; },
/* harmony export */   "fastFilterClick": function() { return /* binding */ fastFilterClick; },
/* harmony export */   "filterClean": function() { return /* binding */ filterClean; },
/* harmony export */   "filterItemClick": function() { return /* binding */ filterItemClick; },
/* harmony export */   "filterRemove": function() { return /* binding */ filterRemove; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7896);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62624);


var buildFilterClick = function buildFilterClick(_ref) {
  var _data$search, _data$search$term;
  var data = _ref.data,
    contentType = _ref.contentType,
    contentId = _ref.contentId;
  var termSearched = (data == null ? void 0 : (_data$search = data.search) == null ? void 0 : (_data$search$term = _data$search.term) == null ? void 0 : _data$search$term.raw) || '';
  return {
    content_id: contentId,
    content_type: contentType,
    event: 'select_content',
    raw: termSearched
  };
};
var fastFilterClick = function fastFilterClick() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    filterValue = _ref2.slug;
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return buildFilterClick((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, args, {
    contentId: "marcas-mais-buscadas:".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(filterValue)),
    contentType: 'busca:filtro-rapido'
  }));
};
var filterClean = function filterClean() {
  var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return buildFilterClick((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, args, {
    contentId: 'limpar-tudo',
    contentType: 'busca:filtro'
  }));
};
var filterItemClick = function filterItemClick() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    filterLabel = _ref3.filterLabel,
    label = _ref3.label,
    _ref3$selected = _ref3.selected,
    selected = _ref3$selected === void 0 ? false : _ref3$selected;
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var action = selected ? 'remover-filtro' : 'aplicar-filtro';
  return buildFilterClick((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, args, {
    contentId: "".concat(action, ":").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(label)),
    contentType: "busca:".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(filterLabel), ":filtro")
  }));
};
var filterRemove = function filterRemove(item) {
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var label = (item == null ? void 0 : item.slug) || '';
  return buildFilterClick((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, args, {
    contentId: "remover-filtro:".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(label)),
    contentType: "busca:filtro"
  }));
};

/***/ }),

/***/ 5503:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "certificatesEventsFooter": function() { return /* binding */ certificatesEventsFooter; },
/* harmony export */   "eventsFooter": function() { return /* binding */ eventsFooter; },
/* harmony export */   "paymentEventsFooter": function() { return /* binding */ paymentEventsFooter; }
/* harmony export */ });
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62624);

var certificatesEventsFooter = function certificatesEventsFooter(data) {
  return {
    content_id: "selo:".concat((data == null ? void 0 : data.title) ? (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(data == null ? void 0 : data.title) : null),
    content_type: 'footer',
    event: 'select_content'
  };
};
var eventsFooter = function eventsFooter(data, title) {
  var titleDepartament = title ? (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(title) : null;
  var label = (data == null ? void 0 : data.content[0].label) ? (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(data == null ? void 0 : data.content[0].label) : null;
  return {
    content_id: "".concat(titleDepartament, ":").concat(label),
    content_type: 'footer',
    event: 'select_content'
  };
};
var paymentEventsFooter = function paymentEventsFooter(data) {
  return {
    content_id: "forma-de-pagamento:".concat((data == null ? void 0 : data.title) ? (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(data == null ? void 0 : data.title) : null),
    content_type: 'footer',
    event: 'select_content'
  };
};

/***/ }),

/***/ 45073:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var importTaxesInfoModalClose = function importTaxesInfoModalClose() {
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: 'produto:compra-internacional',
    eventLabel: 'entendi'
  };
};
/* harmony default export */ __webpack_exports__["default"] = (importTaxesInfoModalClose);

/***/ }),

/***/ 36082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45842);
/* harmony import */ var _accountLinkClick__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51852);
/* harmony import */ var _addToCart__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86963);
/* harmony import */ var _addToWishlist__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72003);
/* harmony import */ var _removeFromWishList__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(25790);
/* harmony import */ var _coupon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38015);
/* harmony import */ var _selectItem__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55544);
/* harmony import */ var _viewItem__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(75589);
/* harmony import */ var _search__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(13075);
/* harmony import */ var _share__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(87889);
/* harmony import */ var _shippingError__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(53827);
/* harmony import */ var _viewItemList__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(20944);
/* harmony import */ var _virtualPageview__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(14093);
/* harmony import */ var _importTaxesInfoModalClose__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(45073);
/* harmony import */ var _calculateTaxes__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(82022);
/* harmony import */ var _showCaseSelectContent__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(41547);
/* harmony import */ var _summaryTechnicalSheet__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(52571);
/* harmony import */ var _selectContent__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(80773);
/* harmony import */ var _selectPromotion__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(4193);
/* harmony import */ var _shipping__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(35468);
/* harmony import */ var _viewPromotion__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(67155);
/* harmony import */ var _reviewFormSubmitModal__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(55442);
/* harmony import */ var _reviewAttachMedia__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(38774);
/* harmony import */ var _reviewCondensedMedia__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(16539);
/* harmony import */ var _orderEligibleList__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(27341);
/* harmony import */ var _footerEvents__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(5503);
/* harmony import */ var _quickClick__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(64233);
/* harmony import */ var _selectContentHeader__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(23620);
/* harmony import */ var _viewContentHeader__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(29371);
/* harmony import */ var _addToCartWarranty__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(81760);
/* harmony import */ var _filterGA4__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(65086);
/* harmony import */ var _sort__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(74359);
/* harmony import */ var _removeFromCart__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(3837);
/* harmony import */ var _allBrands__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(21384);


































var events = {
  'account:link:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_accountLinkClick__WEBPACK_IMPORTED_MODULE_1__["default"])],
  'addToCartWarranty:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_addToCartWarranty__WEBPACK_IMPORTED_MODULE_20__["default"])],
  'addToWishlist:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_addToWishlist__WEBPACK_IMPORTED_MODULE_3__["default"])],
  'allbrands:letter:filter:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_allBrands__WEBPACK_IMPORTED_MODULE_24__.allBrandsLetterFilterClick)],
  'brand:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_allBrands__WEBPACK_IMPORTED_MODULE_24__.brandClick)],
  'coupon:selectItem': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_coupon__WEBPACK_IMPORTED_MODULE_4__.couponClick)],
  'coupon:viewItem': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_coupon__WEBPACK_IMPORTED_MODULE_4__.couponView)],
  'footer:certificate:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_footerEvents__WEBPACK_IMPORTED_MODULE_16__.certificatesEventsFooter)],
  'footer:menu:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_footerEvents__WEBPACK_IMPORTED_MODULE_16__.eventsFooter)],
  'footer:payment:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_footerEvents__WEBPACK_IMPORTED_MODULE_16__.paymentEventsFooter)],
  'header:impression': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_viewContentHeader__WEBPACK_IMPORTED_MODULE_19__["default"])],
  'header:selectContent': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_selectContentHeader__WEBPACK_IMPORTED_MODULE_18__["default"])],
  'order-eligible-list:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_orderEligibleList__WEBPACK_IMPORTED_MODULE_15__.orderEligibleListOnClick)],
  'order-eligible-list:impression': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_orderEligibleList__WEBPACK_IMPORTED_MODULE_15__.orderEligibleListOnViewItemList)],
  'order-eligible-list:onview': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_orderEligibleList__WEBPACK_IMPORTED_MODULE_15__.orderEligibleListOnView)],
  'order-not-eligible:impression': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_orderEligibleList__WEBPACK_IMPORTED_MODULE_15__.orderNotEligibleOnView)],
  pageview: [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_search__WEBPACK_IMPORTED_MODULE_7__["default"]), (0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_virtualPageview__WEBPACK_IMPORTED_MODULE_10__["default"]), (0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_allBrands__WEBPACK_IMPORTED_MODULE_24__.allBrandVirtualPageview)],
  'product:addToCart': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_addToCart__WEBPACK_IMPORTED_MODULE_2__["default"])],
  'product:calculateTaxes': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_calculateTaxes__WEBPACK_IMPORTED_MODULE_25__["default"])],
  'product:details': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_viewItem__WEBPACK_IMPORTED_MODULE_6__["default"])],
  'product:importTaxesClose:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_importTaxesInfoModalClose__WEBPACK_IMPORTED_MODULE_26__["default"])],
  'product:quickClickSelectItem': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_quickClick__WEBPACK_IMPORTED_MODULE_17__.quickClickSelectItem)],
  'product:quickClickViewItemList': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_quickClick__WEBPACK_IMPORTED_MODULE_17__.quickClickViewItemList)],
  'product:removeFromCart': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_removeFromCart__WEBPACK_IMPORTED_MODULE_23__["default"])],
  'product:review:condensedMedia:image:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_reviewCondensedMedia__WEBPACK_IMPORTED_MODULE_14__.clickCondensedMediaImage)],
  'product:review:condensedMedia:video:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_reviewCondensedMedia__WEBPACK_IMPORTED_MODULE_14__.clickCondensedMediaVideo)],
  'product:reviewform:attachimage:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_reviewAttachMedia__WEBPACK_IMPORTED_MODULE_13__.clickAttachImageEvent)],
  'product:reviewform:attachvideo:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_reviewAttachMedia__WEBPACK_IMPORTED_MODULE_13__.clickAttachVideoEvent)],
  'product:reviewform:modal': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_reviewFormSubmitModal__WEBPACK_IMPORTED_MODULE_27__["default"])],
  'product:selectContent': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_selectContent__WEBPACK_IMPORTED_MODULE_11__["default"])],
  'product:selectPromotion': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_selectPromotion__WEBPACK_IMPORTED_MODULE_28__["default"])],
  'product:share': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_share__WEBPACK_IMPORTED_MODULE_29__["default"])],
  'product:shipping': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_shipping__WEBPACK_IMPORTED_MODULE_12__["default"])],
  'product:showcaseSelectContent': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_showCaseSelectContent__WEBPACK_IMPORTED_MODULE_30__["default"])],
  'product:summaryTechnicalSheet': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_summaryTechnicalSheet__WEBPACK_IMPORTED_MODULE_31__["default"])],
  'product:viewItemList': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_viewItemList__WEBPACK_IMPORTED_MODULE_9__["default"])],
  'product:viewPromotion': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_viewPromotion__WEBPACK_IMPORTED_MODULE_32__["default"])],
  'productlist:fastFilter:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_filterGA4__WEBPACK_IMPORTED_MODULE_21__.fastFilterClick)],
  'productlist:filter:clean': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_filterGA4__WEBPACK_IMPORTED_MODULE_21__.filterClean)],
  'productlist:filter:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_filterGA4__WEBPACK_IMPORTED_MODULE_21__.filterItemClick)],
  'productlist:filter:remove': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_filterGA4__WEBPACK_IMPORTED_MODULE_21__.filterRemove)],
  'productlist:selectItem:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_selectItem__WEBPACK_IMPORTED_MODULE_5__["default"])],
  'productlist:sort:change': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_sort__WEBPACK_IMPORTED_MODULE_22__["default"])],
  'removeFromWishList:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_removeFromWishList__WEBPACK_IMPORTED_MODULE_33__["default"])],
  'shipping:response:error': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_shippingError__WEBPACK_IMPORTED_MODULE_8__["default"])]
};
/* harmony default export */ __webpack_exports__["default"] = (events);

/***/ }),

/***/ 27341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "itemAdapter": function() { return /* binding */ itemAdapter; },
/* harmony export */   "orderEligibleListOnClick": function() { return /* binding */ orderEligibleListOnClick; },
/* harmony export */   "orderEligibleListOnView": function() { return /* binding */ orderEligibleListOnView; },
/* harmony export */   "orderEligibleListOnViewItemList": function() { return /* binding */ orderEligibleListOnViewItemList; },
/* harmony export */   "orderNotEligibleOnView": function() { return /* binding */ orderNotEligibleOnView; }
/* harmony export */ });
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62624);

var screenName = 'lista-pedidos-elegiveis';
var itemAdapter = function itemAdapter(item, index) {
  return {
    index: index,
    item_brand: item.productBrand,
    item_id: item.productSku,
    item_name: item.productDescription
  };
};
var orderEligibleListOnClick = function orderEligibleListOnClick(_ref) {
  var displayMode = _ref.displayMode,
    itemSelected = _ref.itemSelected,
    itemIndex = _ref.itemIndex,
    serviceSlug = _ref.serviceSlug;
  return {
    event: 'select_item',
    eventAction: 'click',
    eventCategory: "".concat(screenName, ":").concat(serviceSlug, ":vitrine"),
    eventLabel: "".concat(displayMode, ":").concat(screenName, ":slot-1:").concat(itemSelected.productSku),
    item: itemAdapter(itemSelected, itemIndex + 1),
    item_list_name: screenName,
    mundos: 'magalu',
    nomeLista: "servico:".concat(screenName),
    pageType: 'servico',
    screenName: screenName
  };
};
var orderEligibleListOnView = function orderEligibleListOnView(_ref2) {
  var device = _ref2.device,
    partnerId = _ref2.partnerId,
    seller = _ref2.seller,
    userId = _ref2.userId,
    userIsLogged = _ref2.userIsLogged,
    userLocation = _ref2.userLocation;
  return {
    barraLocalizacao: undefined,
    cepPreenchido: (userLocation == null ? void 0 : userLocation.zipCode) ? 1 : 0,
    cidadeuf: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .locationToString */ .mZ)(userLocation),
    device: "site-".concat(device),
    event: 'virtualPageview',
    existeDelivery: undefined,
    hitTimestamp: new Date().getTime(),
    idDaLoja: seller == null ? void 0 : seller.id,
    idParceiro: partnerId,
    idUsuario: userId,
    loginAtivo: userIsLogged ? 'logado' : 'nao-logado',
    nomeDaLoja: seller == null ? void 0 : seller.description,
    pageType: 'servico',
    screenName: screenName,
    usuarioClube: undefined
  };
};
var orderEligibleListOnViewItemList = function orderEligibleListOnViewItemList(_ref3) {
  var displayMode = _ref3.displayMode,
    products = _ref3.products,
    serviceSlug = _ref3.serviceSlug;
  return {
    event: 'view_item_list',
    eventAction: 'impression',
    eventCategory: "".concat(screenName, ":").concat(serviceSlug, ":vitrine"),
    eventLabel: "".concat(displayMode, ":").concat(screenName, ":slot-1"),
    item_list_name: screenName,
    items: (products || []).map(function (product, index) {
      return itemAdapter(product, index + 1);
    }),
    mundos: 'magalu',
    nomeLista: screenName,
    pageType: 'servico',
    posicaoVitrine: displayMode,
    screenName: screenName
  };
};
var orderNotEligibleOnView = function orderNotEligibleOnView(_ref4) {
  var serviceSlug = _ref4.serviceSlug;
  return {
    content_id: "".concat(screenName, "-indisponivel"),
    content_type: 'servico',
    event: 'view_content',
    serviceSlug: serviceSlug
  };
};

/***/ }),

/***/ 64233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "quickClickSelectItem": function() { return /* binding */ quickClickSelectItem; },
/* harmony export */   "quickClickViewItemList": function() { return /* binding */ quickClickViewItemList; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7896);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62624);
/* harmony import */ var _viewItemList__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20944);
/* harmony import */ var _selectItem__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55544);




var quickClickSelectItem = function quickClickSelectItem(data) {
  var _selectItem, _data$listPosition;
  var buttonLabel = data == null ? void 0 : data.buttonLabel;
  var variationId = decodeURIComponent(data.url).match(/\/p\/([^/]+)/)[1];
  var parsedData = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, data, {
    variationId: variationId
  });
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, (0,_selectItem__WEBPACK_IMPORTED_MODULE_2__["default"])(parsedData), {
    eventLabel: "gallery:".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)((data == null ? void 0 : data.list) || 'null'), ":").concat(buttonLabel ? "".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(buttonLabel), ":") : '', "slot-").concat(data.listPosition),
    items: [(0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, (_selectItem = (0,_selectItem__WEBPACK_IMPORTED_MODULE_2__["default"])(parsedData)) == null ? void 0 : _selectItem.items[0], {
      dimension74: '0:',
      dimension107: (_data$listPosition = data == null ? void 0 : data.listPosition) !== null && _data$listPosition !== void 0 ? _data$listPosition : null
    })]
  });
};
var quickClickViewItemList = function quickClickViewItemList(data) {
  var _viewItemList, _data$listPosition2;
  var buttonLabel = data == null ? void 0 : data.buttonLabel;
  var variationId = decodeURIComponent(data.url).match(/\/p\/([^/]+)/)[1];
  var parsedData = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, data, {
    variationId: variationId
  });
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, (0,_viewItemList__WEBPACK_IMPORTED_MODULE_1__["default"])(parsedData), {
    eventLabel: "gallery:".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)((data == null ? void 0 : data.list) || 'null'), ":").concat(buttonLabel ? "".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(buttonLabel), ":") : '', "slot-").concat(data.listPosition),
    items: [(0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, (_viewItemList = (0,_viewItemList__WEBPACK_IMPORTED_MODULE_1__["default"])(parsedData)) == null ? void 0 : _viewItemList.items[0], {
      dimension74: '0:',
      dimension107: (_data$listPosition2 = data == null ? void 0 : data.listPosition) !== null && _data$listPosition2 !== void 0 ? _data$listPosition2 : null
    })]
  });
};


/***/ }),

/***/ 3837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7896);
/* harmony import */ var _utils_itemVariantParser__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58338);
/* harmony import */ var _utils_parseUrl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62322);
/* harmony import */ var _utils_addToCartDimensions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33637);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62624);
/* harmony import */ var _utils_formattedTagSelo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19175);






var ML2_SID = _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .cookiesConstants.ML2_SID */ .VD.ML2_SID;
var parseItemCategory = function parseItemCategory(category, subcategory) {
  var categoryId = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)((category == null ? void 0 : category.id) || 'null');
  var subcategoryId = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)((subcategory == null ? void 0 : subcategory.id) || 'null');
  return "".concat(categoryId, "/").concat(subcategoryId);
};
var getProductPrice = function getProductPrice(data) {
  var _data$product, _data$product$price, _data$product2, _data$product2$price, _data$product3, _data$product3$instal;
  var bestPrice = parseFloat(data == null ? void 0 : (_data$product = data.product) == null ? void 0 : (_data$product$price = _data$product.price) == null ? void 0 : _data$product$price.bestPrice);
  var fullPrice = parseFloat(data == null ? void 0 : (_data$product2 = data.product) == null ? void 0 : (_data$product2$price = _data$product2.price) == null ? void 0 : _data$product2$price.fullPrice);
  var installmentTotal = parseFloat(data == null ? void 0 : (_data$product3 = data.product) == null ? void 0 : (_data$product3$instal = _data$product3.installment) == null ? void 0 : _data$product3$instal.totalAmount);
  return (data == null ? void 0 : data.pageName) === 'buybox' ? bestPrice || fullPrice || null : installmentTotal || fullPrice || bestPrice || null;
};
var parseEcommerce = function parseEcommerce(data) {
  var _data$product4, _data$product4$brand, _data$product5, _data$product6, _data$product7, _data$product7$rating, _data$product7$rating2, _data$product8, _data$product8$rating, _data$product8$rating2, _data$product9, _data$product$seller$, _data$product10, _data$product10$selle, _data$product$seller$2, _data$product11, _data$product11$selle, _data$product12, _data$product13, _data$product14, _data$product15;
  var _formattedTagSeal = (0,_utils_formattedTagSelo__WEBPACK_IMPORTED_MODULE_2__.formattedTagSeal)(data == null ? void 0 : data.product),
    seal = _formattedTagSeal.seal,
    tag = _formattedTagSeal.tag;
  return {
    items: [(0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
      item_brand: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)((data == null ? void 0 : (_data$product4 = data.product) == null ? void 0 : (_data$product4$brand = _data$product4.brand) == null ? void 0 : _data$product4$brand.label) || 'null'),
      item_category: parseItemCategory(data == null ? void 0 : (_data$product5 = data.product) == null ? void 0 : _data$product5.category, data == null ? void 0 : (_data$product6 = data.product) == null ? void 0 : _data$product6.subcategory),
      item_category3: "qtd-av:".concat((data == null ? void 0 : (_data$product7 = data.product) == null ? void 0 : (_data$product7$rating = _data$product7.rating) == null ? void 0 : (_data$product7$rating2 = _data$product7$rating.count) == null ? void 0 : _data$product7$rating2.toString()) || null, "|av:").concat((data == null ? void 0 : (_data$product8 = data.product) == null ? void 0 : (_data$product8$rating = _data$product8.rating) == null ? void 0 : (_data$product8$rating2 = _data$product8$rating.score) == null ? void 0 : _data$product8$rating2.toString()) || null, "|").concat((data == null ? void 0 : (_data$product9 = data.product) == null ? void 0 : _data$product9.available) ? 'verdadeiro' : 'falso:sem-estoque'),
      item_category4: "ven-por:".concat((_data$product$seller$ = data == null ? void 0 : (_data$product10 = data.product) == null ? void 0 : (_data$product10$selle = _data$product10.seller) == null ? void 0 : _data$product10$selle.id) !== null && _data$product$seller$ !== void 0 ? _data$product$seller$ : null, "|ent-por:").concat((_data$product$seller$2 = data == null ? void 0 : (_data$product11 = data.product) == null ? void 0 : (_data$product11$selle = _data$product11.seller) == null ? void 0 : _data$product11$selle.deliveryId) !== null && _data$product$seller$2 !== void 0 ? _data$product$seller$2 : null),
      item_category5: "selo:".concat(seal, "|tag:").concat(tag),
      item_id: (data == null ? void 0 : (_data$product12 = data.product) == null ? void 0 : _data$product12.variationId) || null,
      item_list_name: "".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)((data == null ? void 0 : data.pageName) || 'null'), ":").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)((data == null ? void 0 : (_data$product13 = data.product) == null ? void 0 : _data$product13.list) || 'null')),
      item_name: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)((data == null ? void 0 : (_data$product14 = data.product) == null ? void 0 : _data$product14.title) || 'null').replace(/[_\s]/g, '-').toLowerCase().slice(0, 99),
      item_variant: (0,_utils_itemVariantParser__WEBPACK_IMPORTED_MODULE_4__.itemVariantParser)(data == null ? void 0 : (_data$product15 = data.product) == null ? void 0 : _data$product15.attributes) || null,
      price: getProductPrice(data),
      quantity: (data == null ? void 0 : data.quantity) || 1
    }, (0,_utils_addToCartDimensions__WEBPACK_IMPORTED_MODULE_0__.addToCartDimensions)(data))]
  };
};
var removeFromCart = function removeFromCart(newData) {
  var _newData$product, _newData$product2, _newData$product3, _data$customer_id;
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    eventId = _ref.eventId;
  var data = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, newData, {
    product: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, newData.product, {
      category: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, newData.product.category, {
        id: newData.product.category.id || (0,_utils_parseUrl__WEBPACK_IMPORTED_MODULE_5__.parseUrl)(newData == null ? void 0 : (_newData$product = newData.product) == null ? void 0 : _newData$product.url, 1)
      }),
      subcategory: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, newData.product.subcategory, {
        id: newData.product.subcategory.id || (0,_utils_parseUrl__WEBPACK_IMPORTED_MODULE_5__.parseUrl)(newData == null ? void 0 : (_newData$product2 = newData.product) == null ? void 0 : _newData$product2.url, 2)
      }),
      variationId: newData.product.variationId || (0,_utils_parseUrl__WEBPACK_IMPORTED_MODULE_5__.parseUrl)(newData == null ? void 0 : (_newData$product3 = newData.product) == null ? void 0 : _newData$product3.url, 0)
    })
  });
  var getEventLabel = function getEventLabel(label) {
    if (label == null ? void 0 : label.typeButton.includes('oneTouch')) {
      return 'comprar-agora';
    }
    if (label == null ? void 0 : label.typeButton.includes('addToBag')) {
      return 'adicionar-a-sacola';
    }
    if (label == null ? void 0 : label.typeButton.includes('pickupStore')) {
      return 'retirar-na-loja';
    }
    return null;
  };
  var basketId = newData.cartId || (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .getCookie */ .ej)(ML2_SID) || null;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    basketId: basketId,
    event: 'remove_from_cart',
    eventCategory: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)(data == null ? void 0 : data.pageName) || null,
    eventId: eventId,
    eventLabel: getEventLabel(data),
    idUsuario: (_data$customer_id = data == null ? void 0 : data.customer_id) !== null && _data$customer_id !== void 0 ? _data$customer_id : null,
    mundos: 'magalu',
    screenName: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)(data == null ? void 0 : data.pageName) || null
  }, parseEcommerce(data));
};
/* harmony default export */ __webpack_exports__["default"] = (removeFromCart);

/***/ }),

/***/ 25790:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var removeFromWishList = function removeFromWishList(eventData) {
  return {
    content_id: "remover-wishlist:".concat((eventData == null ? void 0 : eventData.pageName) || null),
    content_type: (eventData == null ? void 0 : eventData.pageName) || null,
    event: 'select_content',
    item_id: (eventData == null ? void 0 : eventData.variationId) || null
  };
};
/* harmony default export */ __webpack_exports__["default"] = (removeFromWishList);

/***/ }),

/***/ 38774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "clickAttachImageEvent": function() { return /* binding */ clickAttachImageEvent; },
/* harmony export */   "clickAttachVideoEvent": function() { return /* binding */ clickAttachVideoEvent; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7896);

var eventClickAttach = {
  content_type: 'avaliar-produto',
  event: 'select_content'
};
var buildAttachEvent = function buildAttachEvent(contentId, structure) {
  var _structure$config;
  var event = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    content_id: contentId
  }, eventClickAttach);
  if (structure == null ? void 0 : (_structure$config = structure.config) == null ? void 0 : _structure$config.isMiniApp) {
    return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, event, {
      mini_app_name: 'avaliacoes'
    });
  }
  return event;
};
var clickAttachImageEvent = function clickAttachImageEvent(_ref) {
  var structure = _ref.structure;
  return buildAttachEvent('enviar-foto', structure);
};
var clickAttachVideoEvent = function clickAttachVideoEvent(_ref2) {
  var structure = _ref2.structure;
  return buildAttachEvent('enviar-video', structure);
};

/***/ }),

/***/ 16539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "clickCondensedMediaImage": function() { return /* binding */ clickCondensedMediaImage; },
/* harmony export */   "clickCondensedMediaVideo": function() { return /* binding */ clickCondensedMediaVideo; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7896);

var eventClickMedia = {
  content_type: 'produto:avaliacao',
  event: 'select_content'
};
var clickCondensedMediaImage = function clickCondensedMediaImage() {
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, eventClickMedia, {
    content_id: 'imagem-avaliacoes'
  });
};
var clickCondensedMediaVideo = function clickCondensedMediaVideo() {
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, eventClickMedia, {
    content_id: 'video-avaliacoes'
  });
};

/***/ }),

/***/ 55442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7896);

var reviewFormSubmitModal = function reviewFormSubmitModal(_ref) {
  var _structure$config;
  var structure = _ref.structure;
  var eventFormSubmitModal = {
    content_id: 'voltar-ao-inicio',
    content_type: 'avaliacao-concluida',
    event: 'view_content'
  };
  if (structure == null ? void 0 : (_structure$config = structure.config) == null ? void 0 : _structure$config.isMiniApp) {
    return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, eventFormSubmitModal, {
      mini_app_name: 'avaliacao'
    });
  }
  return eventFormSubmitModal;
};
/* harmony default export */ __webpack_exports__["default"] = (reviewFormSubmitModal);

/***/ }),

/***/ 13075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var slugify__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76854);
/* harmony import */ var slugify__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(slugify__WEBPACK_IMPORTED_MODULE_0__);

var search = function search(_ref) {
  var _structure$cookies, _structure$cookies$ac, _structure$route, _structure$route2;
  var data = _ref.data,
    structure = _ref.structure;
  var siteId = structure == null ? void 0 : structure.id;
  var customerId = structure == null ? void 0 : (_structure$cookies = structure.cookies) == null ? void 0 : (_structure$cookies$ac = _structure$cookies.accountData) == null ? void 0 : _structure$cookies$ac.customer_id;
  var eventFrom = structure == null ? void 0 : (_structure$route = structure.route) == null ? void 0 : _structure$route.from;
  var term = structure == null ? void 0 : (_structure$route2 = structure.route) == null ? void 0 : _structure$route2.term;
  var getSearchTermLabel = function getSearchTermLabel() {
    var eventTypes = {
      clickSuggestion: "1:".concat(slugify__WEBPACK_IMPORTED_MODULE_0___default()(term || '')),
      icon: "0:".concat(slugify__WEBPACK_IMPORTED_MODULE_0___default()(term || '')),
      submit: "0:".concat(slugify__WEBPACK_IMPORTED_MODULE_0___default()(term || ''))
    };
    return eventTypes[eventFrom] || "0:".concat(slugify__WEBPACK_IMPORTED_MODULE_0___default()(term || ''));
  };
  if (siteId === 'search') {
    var _data$search, _data$search$term, _data$search2, _data$search2$term, _data$search3, _data$search3$product, _data$search4, _data$search4$term;
    var didCorrectTerm = (data == null ? void 0 : (_data$search = data.search) == null ? void 0 : (_data$search$term = _data$search.term) == null ? void 0 : _data$search$term.refined) !== (data == null ? void 0 : (_data$search2 = data.search) == null ? void 0 : (_data$search2$term = _data$search2.term) == null ? void 0 : _data$search2$term.raw);
    return {
      event: 'search',
      found: (data == null ? void 0 : (_data$search3 = data.search) == null ? void 0 : (_data$search3$product = _data$search3.products) == null ? void 0 : _data$search3$product.length) > 0 ? 'found' : 'not-found',
      loginAtivo: customerId ? 'logado' : 'nao-logado',
      raw: term || null,
      search_term: getSearchTermLabel(),
      wrong_term: "".concat(+didCorrectTerm, ":").concat(data == null ? void 0 : (_data$search4 = data.search) == null ? void 0 : (_data$search4$term = _data$search4.term) == null ? void 0 : _data$search4$term.raw)
    };
  }
  return null;
};
/* harmony default export */ __webpack_exports__["default"] = (search);

/***/ }),

/***/ 80773:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62624);

var getFormatType = function getFormatType(type) {
  var typeMap = {
    "default": 'icone:',
    subsection: 'conheça-tambem:'
  };
  return typeMap[type] || typeMap["default"];
};
var generateContentId = function generateContentId(content, category) {
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var formatType = type !== 'departamento' ? getFormatType(type) : '';
  return "".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(content), ":").concat(formatType).concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(category));
};
var selectContent = function selectContent(content, category) {
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return {
    content_id: generateContentId(content, category, type) || null,
    content_type: 'menu-superior',
    event: 'select_content'
  };
};
/* harmony default export */ __webpack_exports__["default"] = (selectContent);

/***/ }),

/***/ 23620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62624);

var getContentId = function getContentId(content, type) {
  var actions = {
    "default": function _default() {
      return (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(content) || null;
    },
    login: function login() {
      return "login:".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(content) || null);
    },
    menu: function menu() {
      return "menu:".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(content) || null);
    },
    search: function search() {
      return "busca:".concat(content);
    },
    suggestion: function suggestion() {
      return "magalu-has:".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(content) || null);
    },
    zipcode: function zipcode() {
      return content ? "error:".concat(content) : 'sucesso:sucesso';
    }
  };
  var action = actions[type] || actions["default"];
  return action();
};
var selectContentHeader = function selectContentHeader(content) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return {
    content_id: getContentId(content, type),
    content_type: 'menu-superior',
    event: 'select_content'
  };
};
/* harmony default export */ __webpack_exports__["default"] = (selectContentHeader);

/***/ }),

/***/ 55544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7896);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62624);
/* harmony import */ var _utils_discountCalc__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80746);
/* harmony import */ var _utils_itemVariantParser__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58338);
/* harmony import */ var _utils_parseUrl__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62322);
/* harmony import */ var _utils_selectItemDimensions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12608);
/* harmony import */ var _utils_formattedTagSelo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19175);







var parseItemCategory = function parseItemCategory(category, subcategory) {
  var categoryId = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)((category == null ? void 0 : category.id) || 'null');
  var subcategoryId = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)((subcategory == null ? void 0 : subcategory.id) || 'null');
  return "".concat(categoryId, "/").concat(subcategoryId);
};
var priceValue = function priceValue(data) {
  var _data$installment, _data$price, _data$price2;
  return parseFloat(data == null ? void 0 : (_data$installment = data.installment) == null ? void 0 : _data$installment.totalAmount) || parseFloat(data == null ? void 0 : (_data$price = data.price) == null ? void 0 : _data$price.fullPrice) || parseFloat(data == null ? void 0 : (_data$price2 = data.price) == null ? void 0 : _data$price2.bestPrice) || null;
};
var parseEcommerce = function parseEcommerce(data) {
  var _data$brand, _data$rating, _data$rating$count, _data$rating2, _data$rating2$score, _data$seller$id, _data$seller, _data$seller$delivery, _data$seller2, _slug, _slug$replace, _slug$replace$toLower;
  var _formattedTagSeal = (0,_utils_formattedTagSelo__WEBPACK_IMPORTED_MODULE_2__.formattedTagSeal)(data),
    seal = _formattedTagSeal.seal,
    tag = _formattedTagSeal.tag;
  return {
    items: [(0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
      discount: (0,_utils_discountCalc__WEBPACK_IMPORTED_MODULE_4__.getNominalDiscountValue)(data == null ? void 0 : data.installment, data == null ? void 0 : data.price),
      index: (data == null ? void 0 : data.position) || null,
      item_brand: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)((data == null ? void 0 : (_data$brand = data.brand) == null ? void 0 : _data$brand.label) || 'null'),
      item_category: parseItemCategory(data == null ? void 0 : data.category, data == null ? void 0 : data.subcategory),
      item_category3: "qtd-av:".concat((data == null ? void 0 : (_data$rating = data.rating) == null ? void 0 : (_data$rating$count = _data$rating.count) == null ? void 0 : _data$rating$count.toString()) || null, "|av:").concat((data == null ? void 0 : (_data$rating2 = data.rating) == null ? void 0 : (_data$rating2$score = _data$rating2.score) == null ? void 0 : _data$rating2$score.toString()) || null, "|").concat((data == null ? void 0 : data.available) ? 'verdadeiro' : 'falso:sem-estoque'),
      item_category4: "ven-por:".concat((_data$seller$id = data == null ? void 0 : (_data$seller = data.seller) == null ? void 0 : _data$seller.id) !== null && _data$seller$id !== void 0 ? _data$seller$id : null, "|ent-por:").concat((_data$seller$delivery = data == null ? void 0 : (_data$seller2 = data.seller) == null ? void 0 : _data$seller2.deliveryId) !== null && _data$seller$delivery !== void 0 ? _data$seller$delivery : null),
      item_category5: "selo:".concat(seal, "|tag:").concat(tag),
      item_id: (data == null ? void 0 : data.variationId) || null,
      item_list_name: "".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)((data == null ? void 0 : data.pageName) || 'null'), ":").concat((data == null ? void 0 : data.term) || (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)((data == null ? void 0 : data.list) || 'null')),
      item_name: (_slug = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)((data == null ? void 0 : data.title) || 'null')) == null ? void 0 : (_slug$replace = _slug.replace(/[_\s]/g, '-')) == null ? void 0 : (_slug$replace$toLower = _slug$replace.toLowerCase()) == null ? void 0 : _slug$replace$toLower.slice(0, 99),
      item_variant: (0,_utils_itemVariantParser__WEBPACK_IMPORTED_MODULE_5__.itemVariantParser)(data == null ? void 0 : data.attributes) || null,
      price: priceValue(data)
    }, (0,_utils_selectItemDimensions__WEBPACK_IMPORTED_MODULE_1__.selectItemDimensions)(data))]
  };
};
var selectItem = function selectItem(newData) {
  var _data$customer_id;
  var data = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, newData, {
    category: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, newData.category, {
      id: newData.category.id || (0,_utils_parseUrl__WEBPACK_IMPORTED_MODULE_6__.parseUrl)(newData == null ? void 0 : newData.url, 1)
    }),
    subcategory: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, newData.subcategory, {
      id: newData.subcategory.id || (0,_utils_parseUrl__WEBPACK_IMPORTED_MODULE_6__.parseUrl)(newData == null ? void 0 : newData.url, 2)
    }),
    variationId: newData.variationId || (0,_utils_parseUrl__WEBPACK_IMPORTED_MODULE_6__.parseUrl)(newData == null ? void 0 : newData.url, 0)
  });
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    ad_type: (data == null ? void 0 : data.ad_type) || null,
    event: 'select_item',
    eventAction: 'click',
    eventCategory: "".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)((data == null ? void 0 : data.pageName) || 'null'), ":magalu:vitrine"),
    eventLabel: "".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)((data == null ? void 0 : data.displayMode) || 'null'), ":").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)((data == null ? void 0 : data.list) || 'null'), ":slot-null:").concat((data == null ? void 0 : data.position) || null, ":").concat((data == null ? void 0 : data.variationId) || null),
    idUsuario: (_data$customer_id = data == null ? void 0 : data.customer_id) !== null && _data$customer_id !== void 0 ? _data$customer_id : null,
    item_list_name: "".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)((data == null ? void 0 : data.pageName) || 'null'), ":").concat((data == null ? void 0 : data.term) || (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)((data == null ? void 0 : data.list) || 'null')),
    mundos: 'magalu',
    screenName: (data == null ? void 0 : data.pageName) || null
  }, parseEcommerce(data), (data == null ? void 0 : data.term) ? {
    raw: data.term
  } : {});
};
/* harmony default export */ __webpack_exports__["default"] = (selectItem);

/***/ }),

/***/ 4193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var selectPromotion = function selectPromotion(_ref) {
  var _ref$index = _ref.index,
    index = _ref$index === void 0 ? null : _ref$index,
    _ref$text = _ref.text,
    text = _ref$text === void 0 ? null : _ref$text;
  var formattedText = text ? text == null ? void 0 : text.trim().toLowerCase().replace(/\s+/g, '-') : null;
  return {
    content_type: 'hotlink',
    creative_name: 'home:magalu:superhotlinks',
    creative_slot: "slot-".concat(index),
    event: 'select_promotion',
    location_id: "home:".concat(formattedText, ":").concat(index),
    screenName: 'home'
  };
};
/* harmony default export */ __webpack_exports__["default"] = (selectPromotion);

/***/ }),

/***/ 87889:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var share = function share(data) {
  return {
    content_type: 'produto',
    event: 'share',
    item_id: (data == null ? void 0 : data.variationId) || null,
    method: (data == null ? void 0 : data.iconName) || null
  };
};
/* harmony default export */ __webpack_exports__["default"] = (share);

/***/ }),

/***/ 35468:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62624);

var shipping = function shipping(data, _ref) {
  var _data$deliveries, _data$deliveries$, _data$deliveries$$ite, _data$deliveries$$ite2, _data$deliveries2, _data$deliveries2$, _data$deliveries2$$st, _data$deliveries3, _data$deliveries3$, _data$deliveries3$$mo, _data$deliveries3$$mo2, _data$deliveries4, _data$deliveries4$, _data$deliveries4$$mo, _data$deliveries4$$mo2, _data$deliveries5, _data$deliveries5$;
  var structure = _ref.structure;
  var skuProduct = structure.route.productId || (data == null ? void 0 : (_data$deliveries = data.deliveries) == null ? void 0 : (_data$deliveries$ = _data$deliveries[0]) == null ? void 0 : (_data$deliveries$$ite = _data$deliveries$.items) == null ? void 0 : (_data$deliveries$$ite2 = _data$deliveries$$ite[0].seller) == null ? void 0 : _data$deliveries$$ite2.sku) || null;
  var productAvailability = (data == null ? void 0 : (_data$deliveries2 = data.deliveries) == null ? void 0 : (_data$deliveries2$ = _data$deliveries2[0]) == null ? void 0 : (_data$deliveries2$$st = _data$deliveries2$.status) == null ? void 0 : _data$deliveries2$$st.code) ? 'verdadeiro' : 'falso';
  var standardDelivery = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)((data == null ? void 0 : (_data$deliveries3 = data.deliveries) == null ? void 0 : (_data$deliveries3$ = _data$deliveries3[0]) == null ? void 0 : (_data$deliveries3$$mo = _data$deliveries3$.modalities) == null ? void 0 : (_data$deliveries3$$mo2 = _data$deliveries3$$mo[0]) == null ? void 0 : _data$deliveries3$$mo2.name) || 'null');
  var pickUpStore = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)((data == null ? void 0 : (_data$deliveries4 = data.deliveries) == null ? void 0 : (_data$deliveries4$ = _data$deliveries4[0]) == null ? void 0 : (_data$deliveries4$$mo = _data$deliveries4$.modalities) == null ? void 0 : (_data$deliveries4$$mo2 = _data$deliveries4$$mo[1]) == null ? void 0 : _data$deliveries4$$mo2.name) || 'null');
  var deliveryId = (data == null ? void 0 : (_data$deliveries5 = data.deliveries) == null ? void 0 : (_data$deliveries5$ = _data$deliveries5[0]) == null ? void 0 : _data$deliveries5$.id) || (data == null ? void 0 : data.exceptionDeliveriesId) || null;
  var zipCode = (data == null ? void 0 : data.zipCode) || null;
  var status = data.status,
    _data$errorMessageSer = data.errorMessageServer,
    errorMessageServer = _data$errorMessageSer === void 0 ? '' : _data$errorMessageSer,
    _data$errorMessageUse = data.errorMessageUser,
    errorMessageUser = _data$errorMessageUse === void 0 ? '' : _data$errorMessageUse;
  return {
    cep: zipCode,
    code: "".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(status || 'null'), ":").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(errorMessageServer || 'null')),
    content_id: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(errorMessageUser) || null,
    content_type: 'produto:frete',
    deliveriesId: deliveryId,
    event: 'shipping',
    item_id: "".concat(skuProduct, ":").concat(productAvailability, ":").concat(standardDelivery, ":").concat(pickUpStore),
    screenName: 'produto'
  };
};
/* harmony default export */ __webpack_exports__["default"] = (shipping);

/***/ }),

/***/ 53827:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62624);

var shippingError = function shippingError(data) {
  var _data$value, _data$value$error, _data$value2, _data$value3, _data$value4, _data$value5, _data$value6;
  if (!(data == null ? void 0 : (_data$value = data.value) == null ? void 0 : _data$value.errorCode)) return null;
  var errorMessage = (_data$value$error = data == null ? void 0 : (_data$value2 = data.value) == null ? void 0 : _data$value2.error) !== null && _data$value$error !== void 0 ? _data$value$error : 'cep-invalido';
  return {
    cep: (data == null ? void 0 : (_data$value3 = data.value) == null ? void 0 : _data$value3.zipCode) || null,
    code: data == null ? void 0 : (_data$value4 = data.value) == null ? void 0 : _data$value4.errorCode,
    content_type: "produto:frete",
    deliveriesId: (data == null ? void 0 : (_data$value5 = data.value) == null ? void 0 : _data$value5.deliveriesId) || null,
    event: 'shipping_error',
    item_id: "".concat((data == null ? void 0 : (_data$value6 = data.value) == null ? void 0 : _data$value6.productId) || null, ":").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(errorMessage)).substring(0, 99)
  };
};
/* harmony default export */ __webpack_exports__["default"] = (shippingError);

/***/ }),

/***/ 41547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var ShowCaseSelectContent = function ShowCaseSelectContent(data) {
  var _data$showcase;
  var text = "".concat((data == null ? void 0 : data.type) || null, ":").concat((data == null ? void 0 : (_data$showcase = data.showcase) == null ? void 0 : _data$showcase.title) || null, ":slot-").concat((data == null ? void 0 : data.listPosition) || null, ":descubra-outras-ofertas-aqui");
  var formattedText = text ? text.trim().toLowerCase().replace(/\s+/g, '-') : null;
  return {
    content_id: formattedText,
    content_type: "".concat((data == null ? void 0 : data.pageName) || null, ":mundo-magalu:vitrine"),
    event: 'select_content'
  };
};
/* harmony default export */ __webpack_exports__["default"] = (ShowCaseSelectContent);

/***/ }),

/***/ 74359:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62624);

var sort = function sort() {
  var _args$data, _args$data$search, _args$data$search$ter, _data$sort, _data$sort2;
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var termSearched = (args == null ? void 0 : (_args$data = args.data) == null ? void 0 : (_args$data$search = _args$data.search) == null ? void 0 : (_args$data$search$ter = _args$data$search.term) == null ? void 0 : _args$data$search$ter.raw) || '';
  var optionSort = (data == null ? void 0 : (_data$sort = data.sort) == null ? void 0 : _data$sort.label) || '';
  return (data == null ? void 0 : (_data$sort2 = data.sort) == null ? void 0 : _data$sort2.label) && {
    content_id: "ordenacao:".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(optionSort)),
    content_type: 'busca:filtro',
    event: 'select_content',
    raw: termSearched
  };
};
/* harmony default export */ __webpack_exports__["default"] = (sort);

/***/ }),

/***/ 52571:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "summaryTechnicalSheet": function() { return /* binding */ summaryTechnicalSheet; }
/* harmony export */ });
var summaryTechnicalSheet = function summaryTechnicalSheet() {
  return {
    content_id: 'principais-informacoes-do-produto',
    content_type: 'produto:informacao-gerada-por-ia',
    event: 'view_content'
  };
};
/* harmony default export */ __webpack_exports__["default"] = (summaryTechnicalSheet);

/***/ }),

/***/ 29371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62624);

var getContent = function getContent(content, type) {
  var actions = {
    "default": function _default() {
      return (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(content || '') || null;
    },
    error: function error() {
      return "error:".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(content) || null);
    }
  };
  var action = actions[type] || actions["default"];
  return action();
};
var viewContentHeader = function viewContentHeader(content, type) {
  return {
    content_id: getContent(content, type),
    content_type: 'menu-superior',
    event: 'view_content'
  };
};
/* harmony default export */ __webpack_exports__["default"] = (viewContentHeader);

/***/ }),

/***/ 75589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7896);
/* harmony import */ var _utils_viewItemDimensions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87191);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62624);
/* harmony import */ var _utils_itemVariantParser__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58338);
/* harmony import */ var _utils_parseUrl__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62322);
/* harmony import */ var _utils_formattedTagSelo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19175);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30821);







var parseItemCategory = function parseItemCategory(category, subcategory) {
  var categoryId = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)((category == null ? void 0 : category.id) || 'null');
  var subcategoryId = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)((subcategory == null ? void 0 : subcategory.id) || 'null');
  return "".concat(categoryId, "/").concat(subcategoryId);
};
var parseEcommerce = function parseEcommerce(data) {
  var _data$product, _data$product$brand, _data$product2, _data$product3, _data$product4, _data$product4$rating, _data$product4$rating2, _data$product5, _data$product5$rating, _data$product5$rating2, _data$product6, _data$product$seller$, _data$product7, _data$product7$seller, _data$product$seller$2, _data$product8, _data$product8$seller, _data$product9, _slug, _slug$replace, _slug$replace$toLower, _data$product10, _data$product11, _data$product12, _data$product12$insta, _data$product13, _data$product13$price, _data$product14, _data$product14$price;
  var _formattedTagSeal = (0,_utils_formattedTagSelo__WEBPACK_IMPORTED_MODULE_2__.formattedTagSeal)(data == null ? void 0 : data.product),
    seal = _formattedTagSeal.seal,
    tag = _formattedTagSeal.tag;
  return {
    items: [(0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
      item_brand: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)((data == null ? void 0 : (_data$product = data.product) == null ? void 0 : (_data$product$brand = _data$product.brand) == null ? void 0 : _data$product$brand.label) || 'null'),
      item_category: parseItemCategory(data == null ? void 0 : (_data$product2 = data.product) == null ? void 0 : _data$product2.category, data == null ? void 0 : (_data$product3 = data.product) == null ? void 0 : _data$product3.subcategory),
      item_category3: "qtd-av:".concat((data == null ? void 0 : (_data$product4 = data.product) == null ? void 0 : (_data$product4$rating = _data$product4.rating) == null ? void 0 : (_data$product4$rating2 = _data$product4$rating.count) == null ? void 0 : _data$product4$rating2.toString()) || null, "|av:").concat((data == null ? void 0 : (_data$product5 = data.product) == null ? void 0 : (_data$product5$rating = _data$product5.rating) == null ? void 0 : (_data$product5$rating2 = _data$product5$rating.score) == null ? void 0 : _data$product5$rating2.toString()) || null, "|").concat((data == null ? void 0 : (_data$product6 = data.product) == null ? void 0 : _data$product6.available) ? 'verdadeiro' : 'falso:sem-estoque'),
      item_category4: "ven-por:".concat((_data$product$seller$ = data == null ? void 0 : (_data$product7 = data.product) == null ? void 0 : (_data$product7$seller = _data$product7.seller) == null ? void 0 : _data$product7$seller.id) !== null && _data$product$seller$ !== void 0 ? _data$product$seller$ : null, "|ent-por:").concat((_data$product$seller$2 = data == null ? void 0 : (_data$product8 = data.product) == null ? void 0 : (_data$product8$seller = _data$product8.seller) == null ? void 0 : _data$product8$seller.deliveryId) !== null && _data$product$seller$2 !== void 0 ? _data$product$seller$2 : null),
      item_category5: "selo:".concat(seal, "|tag:").concat(tag),
      item_id: (data == null ? void 0 : (_data$product9 = data.product) == null ? void 0 : _data$product9.variationId) || null,
      item_name: (_slug = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)((data == null ? void 0 : (_data$product10 = data.product) == null ? void 0 : _data$product10.title) || 'null')) == null ? void 0 : (_slug$replace = _slug.replace(/[_\s]/g, '-')) == null ? void 0 : (_slug$replace$toLower = _slug$replace.toLowerCase()) == null ? void 0 : _slug$replace$toLower.slice(0, 99),
      item_variant: (0,_utils_itemVariantParser__WEBPACK_IMPORTED_MODULE_5__.itemVariantParser)(data == null ? void 0 : (_data$product11 = data.product) == null ? void 0 : _data$product11.attributes) || null,
      price: parseFloat(data == null ? void 0 : (_data$product12 = data.product) == null ? void 0 : (_data$product12$insta = _data$product12.installment) == null ? void 0 : _data$product12$insta.totalAmount) || parseFloat(data == null ? void 0 : (_data$product13 = data.product) == null ? void 0 : (_data$product13$price = _data$product13.price) == null ? void 0 : _data$product13$price.fullPrice) || parseFloat(data == null ? void 0 : (_data$product14 = data.product) == null ? void 0 : (_data$product14$price = _data$product14.price) == null ? void 0 : _data$product14$price.bestPrice) || null
    }, (0,_utils_viewItemDimensions__WEBPACK_IMPORTED_MODULE_0__.viewItemDimensions)(data))]
  };
};
var viewItem = function viewItem(newData) {
  var _newData$product, _newData$product2, _newData$product3, _data$structure, _data$structure$cooki, _data$structure$cooki2, _data$product15, _data$product15$insta, _data$product16, _data$product16$price, _data$product17, _data$product17$price;
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    eventId = _ref.eventId;
  var data = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, newData, {
    product: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, newData.product, {
      category: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, newData.product.category, {
        id: newData.product.category.id || (0,_utils_parseUrl__WEBPACK_IMPORTED_MODULE_6__.parseUrl)(newData == null ? void 0 : (_newData$product = newData.product) == null ? void 0 : _newData$product.url, 1)
      }),
      subcategory: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, newData.product.subcategory, {
        id: newData.product.subcategory.id || (0,_utils_parseUrl__WEBPACK_IMPORTED_MODULE_6__.parseUrl)(newData == null ? void 0 : (_newData$product2 = newData.product) == null ? void 0 : _newData$product2.url, 2)
      }),
      variationId: newData.product.variationId || (0,_utils_parseUrl__WEBPACK_IMPORTED_MODULE_6__.parseUrl)(newData == null ? void 0 : (_newData$product3 = newData.product) == null ? void 0 : _newData$product3.url, 0)
    })
  });
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    currency: _constants__WEBPACK_IMPORTED_MODULE_3__.CURRENCY,
    event: 'view_item',
    eventId: eventId,
    idUsuario: (data == null ? void 0 : (_data$structure = data.structure) == null ? void 0 : (_data$structure$cooki = _data$structure.cookies) == null ? void 0 : (_data$structure$cooki2 = _data$structure$cooki.accountData) == null ? void 0 : _data$structure$cooki2.customer_id) || null,
    mundos: 'magalu',
    screenName: 'produto',
    value: parseFloat(data == null ? void 0 : (_data$product15 = data.product) == null ? void 0 : (_data$product15$insta = _data$product15.installment) == null ? void 0 : _data$product15$insta.totalAmount) || parseFloat(data == null ? void 0 : (_data$product16 = data.product) == null ? void 0 : (_data$product16$price = _data$product16.price) == null ? void 0 : _data$product16$price.fullPrice) || parseFloat(data == null ? void 0 : (_data$product17 = data.product) == null ? void 0 : (_data$product17$price = _data$product17.price) == null ? void 0 : _data$product17$price.bestPrice) || null
  }, parseEcommerce(data));
};
/* harmony default export */ __webpack_exports__["default"] = (viewItem);

/***/ }),

/***/ 20944:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7896);
/* harmony import */ var _utils_discountCalc__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80746);
/* harmony import */ var _utils_formattedTagSelo__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19175);
/* harmony import */ var _utils_itemVariantParser__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58338);
/* harmony import */ var _utils_parseUrl__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62322);
/* harmony import */ var _utils_selectItemDimensions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12608);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62624);







var parseItemCategory = function parseItemCategory(category, subcategory) {
  var categoryId = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_2__/* .slug */ .oF)((category == null ? void 0 : category.id) || 'null');
  var subcategoryId = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_2__/* .slug */ .oF)((subcategory == null ? void 0 : subcategory.id) || 'null');
  return "".concat(categoryId, "/").concat(subcategoryId);
};
var priceValue = function priceValue(data) {
  var _data$installment, _data$price, _data$price2;
  return parseFloat(data == null ? void 0 : (_data$installment = data.installment) == null ? void 0 : _data$installment.totalAmount) || parseFloat(data == null ? void 0 : (_data$price = data.price) == null ? void 0 : _data$price.fullPrice) || parseFloat(data == null ? void 0 : (_data$price2 = data.price) == null ? void 0 : _data$price2.bestPrice) || null;
};
var getItemListNameValue = function getItemListNameValue(data) {
  var _data$showcase;
  if (data == null ? void 0 : data.term) {
    return data.term;
  }
  var listValue = data == null ? void 0 : data.list;
  var pageNameValue = data == null ? void 0 : data.pageName;
  var showcaseTitle = data == null ? void 0 : (_data$showcase = data.showcase) == null ? void 0 : _data$showcase.title;
  if ((!listValue || listValue === pageNameValue) && showcaseTitle) {
    return showcaseTitle;
  }
  return listValue || 'null';
};
var parseEcommerce = function parseEcommerce(data) {
  var _data$brand, _data$rating, _data$rating$count, _data$rating2, _data$rating2$score, _data$seller$id, _data$seller, _data$seller$delivery, _data$seller2;
  var _formattedTagSeal = (0,_utils_formattedTagSelo__WEBPACK_IMPORTED_MODULE_0__.formattedTagSeal)(data),
    seal = _formattedTagSeal.seal,
    tag = _formattedTagSeal.tag;
  var listNameValue = getItemListNameValue(data);
  return {
    items: [(0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
      discount: (0,_utils_discountCalc__WEBPACK_IMPORTED_MODULE_4__.getNominalDiscountValue)(data == null ? void 0 : data.installment, data == null ? void 0 : data.price),
      index: (data == null ? void 0 : data.position) || null,
      item_brand: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_2__/* .slug */ .oF)((data == null ? void 0 : (_data$brand = data.brand) == null ? void 0 : _data$brand.label) || 'null'),
      item_category: parseItemCategory(data == null ? void 0 : data.category, data == null ? void 0 : data.subcategory),
      item_category3: "qtd-av:".concat((data == null ? void 0 : (_data$rating = data.rating) == null ? void 0 : (_data$rating$count = _data$rating.count) == null ? void 0 : _data$rating$count.toString()) || null, "|av:").concat((data == null ? void 0 : (_data$rating2 = data.rating) == null ? void 0 : (_data$rating2$score = _data$rating2.score) == null ? void 0 : _data$rating2$score.toString()) || null, "|").concat((data == null ? void 0 : data.available) ? 'verdadeiro' : 'falso:sem-estoque'),
      item_category4: "ven-por:".concat((_data$seller$id = data == null ? void 0 : (_data$seller = data.seller) == null ? void 0 : _data$seller.id) !== null && _data$seller$id !== void 0 ? _data$seller$id : null, "|ent-por:").concat((_data$seller$delivery = data == null ? void 0 : (_data$seller2 = data.seller) == null ? void 0 : _data$seller2.deliveryId) !== null && _data$seller$delivery !== void 0 ? _data$seller$delivery : null),
      item_category5: "selo:".concat(seal, "|tag:").concat(tag),
      item_id: (data == null ? void 0 : data.variationId) || null,
      item_list_name: "".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_2__/* .slug */ .oF)((data == null ? void 0 : data.pageName) || 'null'), ":").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_2__/* .slug */ .oF)(listNameValue)),
      item_name: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_2__/* .slug */ .oF)((data == null ? void 0 : data.title) || 'null').replace(/[_\s]/g, '-').toLowerCase().slice(0, 99),
      item_variant: (0,_utils_itemVariantParser__WEBPACK_IMPORTED_MODULE_5__.itemVariantParser)(data == null ? void 0 : data.attributes) || null,
      price: priceValue(data)
    }, (0,_utils_selectItemDimensions__WEBPACK_IMPORTED_MODULE_1__.selectItemDimensions)(data))]
  };
};
var viewItemList = function viewItemList(newData) {
  var _data$customer_id;
  var data = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, newData, {
    category: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, newData.category, {
      id: newData.category.id || (0,_utils_parseUrl__WEBPACK_IMPORTED_MODULE_6__.parseUrl)(newData == null ? void 0 : newData.url, 1)
    }),
    subcategory: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, newData.subcategory, {
      id: newData.subcategory.id || (0,_utils_parseUrl__WEBPACK_IMPORTED_MODULE_6__.parseUrl)(newData == null ? void 0 : newData.url, 2)
    }),
    variationId: newData.variationId || (0,_utils_parseUrl__WEBPACK_IMPORTED_MODULE_6__.parseUrl)(newData == null ? void 0 : newData.url, 0)
  });
  var listNameValue = getItemListNameValue(data);
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    ad_type: (data == null ? void 0 : data.ad_type) || null,
    event: 'view_item_list',
    eventAction: 'impression',
    eventCategory: "".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_2__/* .slug */ .oF)((data == null ? void 0 : data.pageName) || 'null'), ":magalu:vitrine"),
    eventLabel: "".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_2__/* .slug */ .oF)((data == null ? void 0 : data.displayMode) || 'null'), ":").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_2__/* .slug */ .oF)((data == null ? void 0 : data.list) || 'null'), ":slot-").concat((data == null ? void 0 : data.position) || null),
    idUsuario: (_data$customer_id = data == null ? void 0 : data.customer_id) !== null && _data$customer_id !== void 0 ? _data$customer_id : null,
    item_list_name: "".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_2__/* .slug */ .oF)((data == null ? void 0 : data.pageName) || 'null'), ":").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_2__/* .slug */ .oF)(listNameValue)),
    mundos: 'magalu',
    screenName: (data == null ? void 0 : data.pageName) || null
  }, parseEcommerce(data), (data == null ? void 0 : data.term) ? {
    raw: data.term
  } : {});
};
/* harmony default export */ __webpack_exports__["default"] = (viewItemList);

/***/ }),

/***/ 67155:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var viewPromotion = function viewPromotion(_ref) {
  var _ref$index = _ref.index,
    index = _ref$index === void 0 ? null : _ref$index,
    _ref$text = _ref.text,
    text = _ref$text === void 0 ? null : _ref$text;
  var formattedText = text ? text.trim().toLowerCase().replace(/\s+/g, '-') : null;
  return {
    content_type: 'hotlink',
    creative_name: 'home:magalu:superhotlinks',
    creative_slot: "slot-".concat(index),
    event: 'view_promotion',
    location_id: "home:".concat(formattedText, ":").concat(index),
    screenName: 'home'
  };
};
/* harmony default export */ __webpack_exports__["default"] = (viewPromotion);

/***/ }),

/***/ 14093:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62624);

var formatLocation = function formatLocation(location) {
  if ((location == null ? void 0 : location.zipCodeCity) && (location == null ? void 0 : location.zipCodeState)) {
    return "cep:".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(location.zipCode), ":").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(location.zipCodeCity), ":").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(location.zipCodeState));
  }
  return null;
};
var getLoginStatus = function getLoginStatus(customerId) {
  return customerId ? 'logado' : 'nao-logado';
};
var virtualPageview = function virtualPageview(_ref) {
  var _structure$cookies2, _data$product, _data$product$categor, _data$product2, _data$product2$subcat;
  var data = _ref.data,
    structure = _ref.structure;
  var siteId = structure.id,
    _structure$cookies = structure.cookies,
    cookies = _structure$cookies === void 0 ? {} : _structure$cookies,
    device = structure.device;
  var cookiesLocation = cookies == null ? void 0 : cookies.location;
  var accountData = (structure == null ? void 0 : (_structure$cookies2 = structure.cookies) == null ? void 0 : _structure$cookies2.ml2_sid_c) || null;
  var customerId = (accountData == null ? void 0 : accountData.customer_id) || null;
  var clientId = (cookies == null ? void 0 : cookies.clientId) || null;
  var category = (data == null ? void 0 : (_data$product = data.product) == null ? void 0 : (_data$product$categor = _data$product.category) == null ? void 0 : _data$product$categor.id) || null;
  var subCategory = (data == null ? void 0 : (_data$product2 = data.product) == null ? void 0 : (_data$product2$subcat = _data$product2.subcategory) == null ? void 0 : _data$product2$subcat.id) || null;
  var location = {
    zipCode: cookiesLocation == null ? void 0 : cookiesLocation.zipCode,
    zipCodeCity: cookiesLocation == null ? void 0 : cookiesLocation.zipCodeCity,
    zipCodeState: cookiesLocation == null ? void 0 : cookiesLocation.zipCodeState
  };
  if (siteId === 'buybox') {
    return {
      buybox: 1,
      cepPreenchido: location.zipCode ? 1 : 0,
      cidadeuf: formatLocation(location),
      clientId: clientId,
      device: device || null,
      event: 'virtualPageview',
      idUsuario: customerId || null,
      loginAtivo: getLoginStatus(customerId),
      mundos: 'magalu',
      pageCategory: "".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(category) || null, ":").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(subCategory) || null),
      pageType: 'produto',
      screenName: 'produto',
      usuarioClube: null
    };
  }
  return null;
};
/* harmony default export */ __webpack_exports__["default"] = (virtualPageview);

/***/ }),

/***/ 57016:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* reexport safe */ _events__WEBPACK_IMPORTED_MODULE_0__["default"]; }
/* harmony export */ });
/* harmony import */ var _events__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36082);


/***/ })

}]);